import { i18nPrefix } from './fleet-overview-i18n'

const fleetOverviewPt = Object.entries({
    'Fleet Overview Performance': 'Desempenho da Frota',
    'New Rule': 'Nova Regra',
    'Edit Rule': 'Editar Regra',
    'Asset Control': 'Controle de Ativos',
    'Data Control': 'Controle de Dados',
    Path: 'Caminho',
    Performance: 'Performance',
    'KPI Context': 'Contexto de KPI',
    'Rigs and Wells': 'Sondas e Poços',
    'Rig Floor': 'Rig Floor',
    'Wells Flat Time': 'Flat Time dos Poços',
    'Search Items': 'Buscar Itens',
    'Sort by': 'Ordenar por',
    'Alphabetical - Ascending': 'Alfabética - Crescente',
    Alphabetical: 'Alfabética',
    'Alphabetical - Descending': 'Alfabética - Decrescente',
    'Select timespan': 'Selecionar período',
    'Last 30 days': 'Últimos 30 dias',
    Layout: 'Layout',
    'Filter Result:': 'Resultado do Filtro:',
    Quality: 'Qualidade',
    'Restore default': 'Restaurar padrão',
    'Live: Performance UI Overview': 'Live: Visão Geral da UI de Performance',
    'No results found': 'Nenhum resultado encontrado',
    'Please make a new search': 'Por favor, faça uma nova busca',
    'No asset found': 'Nenhum ativo encontrado',
    'No data': 'Sem dados',
    'This asset has no data available for the selected period.':
        'Este ativo não possui dados disponíveis para o período selecionado.',
    selected: 'selecionado(s)',
    'Unable to execute menu action.': 'Não foi possível executar a ação do menu.',
    'Open rig actions': 'Abrir ações da sonda',
    'Operational Lifecycle': 'Ciclo de Vida Operacional',
    'Rig Configuration': 'Configuração da Sonda',
    'Real time monitoring': 'Monitoramento em tempo real',
    'Integration and editing': 'Integração e edição',
    'Operational Analytics': 'Análise Operacional',
    'Standard dashboards': 'Dashboards padrão',
    'Dynamic Dashboards': 'Dashboards Dinâmicos',
    'Compact Card': 'Cartão Compacto',
    'Detailed Card': 'Cartão Detalhado',
    Chart: 'Gráfico',
    List: 'Lista',
    'Permission Required': 'Permissão Necessária',
    'To view the chart, you must have one of the following permissions: Admin or Manage Pipe Widgets.':
        'Para ver este gráfico, você precisa ter uma das seguintes permissões: Admin ou Gerenciar Widgets Pipes.',
    'Back to Performance': 'Voltar para Performance',
    'Rig name': 'Nome da sonda',
    'Event Integrity': 'Integridade de Eventos',
    'KPI Omission': 'Omissão de KPI',
    'Data Control and Quality': 'Controle e Qualidade de Dados',
    Control: 'Controle',
    'Dynamic Dashboard Library': 'Biblioteca de Dashboards Dinâmicos',
    'Rigs and Wells Fleet Dynamic Dashboard': 'Rigs and Wells Fleet Dynamic Dashboard',
    OLC: 'CVO',
    OA: 'AO',
    RPI: 'IDS',
    Consistency: 'Consistência',
    'Pot. Savings': 'Econ. Potencial',
    ILT: 'Tempo perdido oculto',
    'Goal Gains': 'Ganhos da Meta'
}).reduce(
    (acc, [key, value]) => ({
        ...acc,
        [`${i18nPrefix}${key}`]: value
    }),
    {}
)

export const ptBr = {
    values: {
        'Loading...': 'Carregando...',
        'No data': 'Sem dados',
        'No data found': 'Nenhum dado encontrado',
        'No data in this range': 'Nenhum dado neste intervalo',
        'KPI Configuration': 'Configuração de KPI',
        'KPI Context': 'Contexto do KPI',
        'Channels interpolation': 'Interpolação de canais',
        'KPI generation methodology': 'Metodologia de geração de KPI',
        'Event span': 'Intervalo do evento',
        Status: 'Status',
        'Rig Floor Output Event Type': 'Rig Floor evento de saída',
        drilling: 'perfuração',
        tripping: 'manobra Descida/Subida',
        casing: 'revestimento',
        'Shifts Configuration': 'Configuração de Turno',
        Color: 'Cor',
        'Start.': 'Início',
        End: 'Fim',
        'Are you sure you want to discard all changes?': 'Tem certeza de que deseja descartar todas as alterações?',
        'Are you sure you want to save all changes': 'Tem certeza que quer salvar todas as alterações',
        SAVE: 'SALVAR',
        DISCARD: 'DESCARTAR',
        'Discard changes': 'Descartar mudanças',
        'KPI Channels Configuration': 'Configurações de canais KPI',
        NAME: 'NOME',
        UNIT: 'UNIDADE',
        VALUE: 'VALOR',
        Author: 'Autor',
        'MIN VALUE': 'VALOR MIN',
        TARGET: 'OBJETIVO',
        'MAX VALUE': 'VALOR MAX',
        'CASED HOLE': 'POÇO REVESTIDO',
        'OPEN HOLE': 'POÇO ABERTO',
        'discard changes': 'descartar mudanças',
        'No changes to discard': 'Não há mudanças a serem descartadas',
        'No changes to save': 'Não há mudanças a serem salvas',
        'Save changes': 'Salvar Alterações',
        'GLOBAL CONFIG': 'CONFIGURAÇÕES GLOBAIS',
        'ADD NEW SHIFT': 'ADICIONAR TURNO',
        'Last Saved': 'Última Alteração',
        'Expand Table': 'Expandir Tabela',
        'Default Shifts': 'Turnos Padrão',
        'Please check': 'Por favor corrija',
        'Shift with the same color': 'Turnos com a mesma cor',
        'Overlaping time': 'Conflito entre turnos',
        'minutes unaccounted for': 'minutos não designados',
        'Fields with empty values': 'Campos com valores vazios',
        'Something went wrong': 'Algo deu errado',
        Shift: 'Turno',
        SHIFTS: 'TURNOS',
        'KPI PARAMETERS': 'PARÂMETROS DOS INDICADORES',
        'GENERAL SETTINGS': 'CONFIGURAÇÕES GERAIS',
        'DRILLING KPIs': 'INDICADORES DE PERFURAÇÃO',
        'CASING KPIs': 'INDICADORES DE REVESTIMENTO',
        'TRIPPING KPIs': 'INDICADORES DE MANOBRA',
        'Block Weight': 'Peso do Bloco',

        // Novo
        'Multi KPIs Chart': 'Gráficos Multi KPIs',
        'Apply Filters': 'Aplicar Filtros',
        Apply: 'Aplicar',
        Cancel: 'Cancelar',
        Histogram: 'Histograma',
        Reset: 'Limpar',
        'USER FAVORITES': 'FAVORITOS',
        'Static Data options are enabled for KPI Data Source and can be turned on or off as you like.':
            'As opções de dados estáticos são ativadas para fonte de dados KPI e podem ser ativadas ou desativadas conforme você desejar.',
        'A curve that represents the cumulative frequency distribution of grouped data on a graph.':
            'Um curva cumulativa representa a frequência de distribuição de um grupo de dados no gráfico.',
        'Cumulative Distribution Curve': 'Curva de Distribuição Cumulativa',
        'VISUALIZATION OPTIONS': 'OPÇÕES DE VISUALIZAÇÃO',
        'Number of Bins': 'Número de Bins',
        'Max Value': 'Valor Máximo',
        'Min Value': 'Valor Mínimo',
        'Max value cannot be less than Min value.': 'O valor mmáximo não pode ser menor do que os valores máximos.',
        'Min value cannot be greater than Max value.': 'O valor mínimo não pode ser maior do que os valores máximos.',
        THRESHOLDS: 'LIMITES',
        'Type to search': 'Digite para pesquisar',
        'items selected': 'itens selecionados',
        Timespan: 'Intervalo de tempo',
        Intervention: 'Intervenção',
        Rigs: 'Sondas',
        Wells: 'Poços',
        'Start with': 'Iniciar com',
        'add percentile mark': 'adicionar percentil',
        Period: 'Período',
        'Select a KPI': 'Selecione um KPI',
        'Select KPIs': 'Selecionar KPIs',
        ' Select a rig': 'Selecione uma sonda',
        ' Select a well': 'Selecione um poço',
        'All rigs selected': 'Todas as sondas',
        'All wells selected': 'Todos os poços',
        Type: 'Tipo',
        Rig: 'Sonda',
        Well: 'Poço',
        'All timespan selected': 'Intervalos de tempo selecionados',
        'One or more fields have an error. Please check and try again.':
            'Um ou mais dois campos estão incompletos. Por favor verifique e tente novamente.',
        'Invalid Time Span': 'Time Span inválido',
        'Marks on the graph a target mark that allows visualizing and comparing the proximity of the data distribution with the desired target value.':
            'Marca no gráfico uma alvo que permite visualizar e comparar a proximidade da distribuição dos dados com o valor alvo desejado.',
        'Displays a curve that describes the frequency distribution of a KPI.':
            'Exibe uma curva que descreve a distribuição de frequência de um KPI.',
        items: 'itens',
        'All intervention selected': 'Intervenções selecionadas',
        'interventions selected': 'intervenções selecionadas',
        'Data & Filters': 'Dados & Filtros',
        'Chart Settings': 'Configurações',
        Templates: 'Modelos',
        ' items selected of ': ' itens selecionados de ',
        FREQUENCY: 'FREQUÊNCIA',
        CUMULATIVE: 'CUMULATIVO',
        'Type to search...': 'Digite para pesquisar...',
        Presets: 'Predefinições',
        'Field is missing, please check and try again.': 'Campo faltando, verifique e tente novamente.',
        'The amount of data periods that will be analyzed.': 'Quantidade de períodos de dados que serão analisados.',
        'All time': 'Todo o período',
        'last day': 'Último dia',
        'last week': 'Última semana',
        'last 15 days': 'Últimos 15 dias',
        'last month': 'Último mês',
        'last quarter': 'Último trimestre',
        'last semester': 'Último semestre',
        'last year': 'Último ano',
        'Last day': 'Último dia',
        'Last week': 'Última semana',
        'Last 15 days': 'Ultimos 15 dias',
        'Last month': 'Último mês',
        'Last quarter': 'Último trimestre',
        'Last semester': 'Último semestre',
        'Last year': 'Último ano',
        Advanced: 'Avançado',
        'Standard Deviation': 'Desvio Padrão',
        'Add New Template': 'Adicionar novo Modelo',
        'Template name...': 'Nome do Modelo...',
        'Save current config': 'Salvar configuração atual',
        'Save Template': 'Salvar Template',
        'Cancel changes': 'Cancelar alterações',
        'Apply Template': 'Aplicar Template',
        'Edit Template': 'Editar Template',
        'Delete Template': 'Deletar Template',
        Edit: 'Editar',
        'KPI/Channel': 'KPI/Canal',
        'No intervetions selected': 'Sem intervenções selecionadas',
        'All Timespan selected': 'Todo o período',
        'Select a chart type...': 'Selecione o tipo de gráfico...',
        'Save this widget and return to the dashboard.': 'Salvar widget e retornar para o dashboard.',
        'Filters and settings are displayed in visualization mode only.':
            'Filtros e configurações são exibidos apenas no modo de visualização.',
        Cumulative: 'Cumulativo',
        'Select a KPI/Channel': 'Selecione um KPI/Channel',
        EVENTS: 'EVENTOS',
        'Potential Savings': 'Economia de Tempo',
        'since ts 0': 'Todo o período',
        All: 'Todos',
        'All Rigs': 'Todas',
        'All Quality': 'Todas',
        'TARGET(MEDIAN)': 'TARGET(MEDIANA)',
        'POTENTIAL SAVINGS': 'ECONOMIA DE TEMPO',
        'BELOW TARGET': 'ABAIXO DA META',
        'ABOVE TARGET': 'ACIMA DA META',
        'TOTAL SAVED': 'TOTAL ECONOMIZADO',
        TOTAL: 'TOTAL',
        Median: 'Mediana',
        'Target must be greater than zero': 'Valor objetivo deve ser maior que zero.',
        'Degree of dispersion of a data set. Indicates how uniform a data set is. The closer to zero the standard deviation, the more homogeneous the data are.':
            'Grau de dispersão de um conjunto de dados. Indica o quão uniforme é um conjunto de dados. Quanto mais próximo de 0 o desvio padrão, mais homogêneos são os dados.',
        'Shows the time sums above and below the target (if there is no target, consider the median). The difference between these values is the total time saved, if greater than zero, or wasted, otherwise.':
            'Mostra os somatórios de tempo acima e abaixo do alvo (se não há um alvo, considera a mediana). A diferença entre estes valores é o total de tempo economizado, se maior que zero, ou perdido, caso contrário.',
        HISTOGRAM: 'HISTOGRAMA',
        'Changes applied with success': 'Mudanças salvas com sucesso',
        'Template applied.': 'Template aplicado.',
        'Current config saved on Template.': 'Configuração atual salva no Template.',

        // BOXPLOT
        thresholds: 'limites',
        'Min Value': 'Valor Mínimo',
        'Max Value': 'Valor Máximo',
        'visualization options': 'opções de visualização',
        'Dot Values': 'Valores de pontos',
        Outliers: 'Valores discrepantes',
        'Goal/Target': 'Meta/Alvo',
        'Mean Value': 'Média aritmética',
        'Shows a line across the graph, which allows you to view the position of the single Goal/Target for all boxplot in the timespan.':
            'Mostra uma linha ao longo do gráfico, que permite visualizar a posição de uma única Meta/Alvo para todos os boxplot no intervalo de tempo.',
        'Shows the value and position of the arithmetic mean in each boxplot.':
            'Mostra o valor e a posição da média aritmética em cada boxplot.',
        'DATA SOURCE': 'FONTE DE DADOS',
        'BOXPLOT GROUPS': 'GRUPOS DE BOXPLOT',
        'No option set': 'Nenhuma opção definida',
        'Grouping Type': 'Tipo de Agrupamento',
        'Break Time': 'Intervalo',
        Periods: 'Períodos',
        'Over Time Comparison': 'Comparativo ao Longo do Tempo',
        'Consecutive Break Grouping': 'Agrupamento de Intervalos Consecutivos',
        'Cumulative Break Grouping': 'Agrupamento de Intervalos Cumulativos',
        'One Boxplot Every': 'Um Boxplot a Cada',
        '12 Hours': '12 Horas',
        dayKeyForI18n: 'Dia',
        Week: 'Semana',
        Month: 'Mês',
        Quarter: 'Trimestre',
        Semester: 'Semestre',
        Year: 'Ano',
        'Boxplot was successfully generated with the current config':
            'Boxplot foi gerado com sucesso com a configuração atual',
        "Boxplot couldn't be generated": 'Não foi possível gerar o Boxplot',
        'You need to configure Boxplot Groups type.': 'Você precisa configurar o tipo de Grupos de Boxplot.',
        'Contact the administrator.': 'Entre em contato com o administrador.',
        'Maximum Value': 'Valor Máximo',
        'Minimum Value': 'Valor Mínimo',
        'Upper Quartile': 'Quartil Superior',
        'Lower Quartile': 'Quartil Inferior',
        'Number of events': 'Número de eventos',
        'Mean Value': 'Valor Médio',
        Outlier: 'Valor discrepante',
        // BoxPlot Messages error
        'Asset map must not be null.': 'Filtro de ativos não deve ser nulo.',
        'Start time must be greater than 0.': 'A hora de início deve ser maior que 0.',
        'End time must be greater than 0.': 'A hora final deve ser maior que 0.',
        'End time must be after start time.': 'A hora final deve ser posterior a hora de início.',
        'Entity type must not be null.': 'O tipo de entidade não deve ser nulo.',
        'Entity type filter must not be null or empty.': 'O filtro de tipo de entidade não deve ser nulo ou vazio.',
        'Minimum value must not be null.': 'O valor mínimo não deve ser nulo.',

        // Dicionário
        Entity: 'Entidade',
        'Entity Type': 'Tipo de Entidade',
        'Generated Token': 'Token Gerado',
        'Final Token': 'Token Final',
        'Final token': 'Token final',
        'Last Update': 'Última Atualização',
        'Dictionary Entries': 'Entradas do Dicionário',
        'Acronym Dictionary': 'Dicionário de Acrônimos',
        'Code Dictionary': 'Dicionário de Código',
        'Code Management': 'Gerenciamento de Códigos',
        'Manage how codes are displayed across the platform. Changes here override the default mapping defined in the Code Dictionary.':
            'Gerencie como os códigos são exibidos na plataforma. Alterações aqui substituem o mapeamento padrão definido no Dicionário de Código.',
        'kpi description': 'Descrição do KPI',
        'display code': 'Código de Exibição',
        'Search dictionary...': 'Pesquisar dicionário...',
        'No dictionary entries found': 'Nenhuma entrada de dicionário encontrada',
        'The edited dictionary entry is no longer available. Please refresh the list and try again.':
            'A entrada do dicionário editada não está mais disponível. Por favor, atualize a lista e tente novamente.',
        'is already in use. Please choose a different token.': 'já está em uso. Por favor, escolha um token diferente.',
        'Dictionary entry created successfully.': 'Entrada do dicionário criada com sucesso.',
        'Dictionary entry updated successfully.': 'Entrada do dicionário atualizada com sucesso.',
        'Dictionary entry deleted successfully.': 'Entrada do dicionário excluída com sucesso.',
        'Failed to create dictionary entry.': 'Falha ao criar a entrada do dicionário.',
        'Failed to update dictionary entry.': 'Falha ao atualizar a entrada do dicionário.',
        'Failed to delete dictionary entry.': 'Falha ao excluir a entrada do dicionário.',
        edit: 'editar',
        delete: 'deletar',
        'Maximum value must not be null.': 'O valor máximo não deve ser nulo.',
        'Grouping type must not be null.': 'O tipo de agrupamento não deve ser nulo.',
        'Break type must not be null.': 'O tipo de quebra não deve ser nulo.',
        'Break period must not be null.': 'O período de quebra não deve ser nulo.',
        'User time zone must not be null or empty.': 'Erro ao obter o fuso horário.',
        'Insufficient memory resources.': 'Recursos de memória insuficientes.',
        'An error occurred.': 'Ocorreu um erro.',

        // Novo
        'Annotation Tool': 'Ferramenta de Anotação',
        'Review Options': 'Opções de Revisão',
        'Review Option': 'Opção de Revisão',
        'Select period': 'Selecionar período',
        'Select asset': 'Selecionar ativo',
        'Zoom In': 'Ampliar',
        'Zoom Out': 'Reduzir',
        'Reset Zoom': 'Redefinir',
        Options: 'Opções',
        'View KPIs': 'Ver KPIs',
        'Select method...': 'Selecionar método...',
        'Select method': 'Selecionar método',
        'Sequential Time Review': 'Revisão de Tempo Sequencial',
        'Cutoff Filters (Min, Max, Relative Deviation)': 'Filtros de Atalho (Mín, Max, Desvio Relativo)',
        'Zoom Settings': 'Configurações de zoom',
        'All Time': 'Todo o período',
        'Every 3 minutes': 'A cada 3 minutos',
        'Every 15 minutes': 'A cada 15 minutos',
        'Every 30 minutes': 'A cada 30 minutos',
        'Every 20 minutes': 'A cada 20 minutos',
        'Every hour': 'A cada hora',
        'Every Two Hours': 'A cada Duas Hora',
        'Every KPIs': 'Every KPIs',
        'Every 2 KPIs': 'Every 2 KPIs',
        'Every 3 KPIs': 'Every 3 KPIs',
        'Every 5 KPIs': 'Every 5 KPIs',
        'Below Min': 'Mín Abaixo',
        'Above Max': 'Max Acima',
        Deviation: 'Desvio',
        'TOOLTIP COLOR': 'ESTILO DO TOOLTIP',
        'CHANNEL OPTIONS': 'OPÇÕES DO CANAL',
        'KPIS REVIEW PANE': 'INSPECIONAR KPIS',
        'See kpis': 'Ver kpis',

        'is a system pattern that can be overriden in each rig parameters.':
            'é um padrão do sistema que pode ser sobrescrito na página de parâmetros de cada sonda.',
        'For some reason, no shift information was returned. Check your connection and try again later.':
            'Por algum motivo, não foi encontrado nenhuma configuração de turno. Verifique sua internet e tente novamente mais tarde.',
        "For some reason, your request couldn't be saved": 'Por algum motivo, as informações não puderam ser salvas',
        'It is not possible to add more than 6 shifts.': 'Não é possível adicionar mais de 6 turnos.',
        'At least one shift has to be configured.': 'Pelo menos um turno deve estar configurado.',
        'Algorithm Thresholds': 'Limites do Algoritmo',
        'Target Settings': 'Configurações de Objetivo',
        'Colors Configuration': 'Configuração de Cores',
        'Colors Settings': 'Definição de Cores',
        'Colors saved successfully.': 'Cores salvas com sucesso.',
        Identification: 'Identificação',
        'Value must be bigger than zero': 'O valor deve ser maior que zero',
        'Value smaller than or equal to min value': 'Valor menor ou igual ao valor mínimo',
        'Value smaller than or equal to target value': 'Valor menor ou igual ao valor objetivo',
        'Value larger than or equal to target value': 'Valor maior ou igual ao valor objetivo',
        'Value larger than or equal to max value': 'valor maior ou igual ao valor máximo',
        'Default operation shifts should be applied to all active rigs, unless there is a different profile defined here in this section.':
            'As configurações padrão de turno serão aplicadas a todas as sondas a não ser que seja definido um perfil diferente.',
        'Values set here will affect rig values with overriden parameters which can be accessed on each rig option on the “Operational Targets” tab.':
            'Os valores configurados aqui podem ser sobrescritos na pagina individual de cada sonda na aba "Objetivos Operacionais" ',
        "Use this page to configure how crew's shifts should be assingned. The shifts should each have a diferent color and a different time span. No shift can overlap with another. You can configure between 1 and 6 shifts.":
            'Use essa pagina para configurar como cada turno de uma equipe deve ser designado. Cada turno deve ter uma cor e um período diferente. Não é permitido que haja sobreposição dos horários de cada turno. Você pode configurar entre 1 e 6 turnos.',
        'This time represents the time spent since the operator turns off the pumps until the moment the pump brings the flow again. Actually it is the time without flow rate.':
            'Representa o tempo gasto do momento em que o operador desliga as bombas até o momento em que as bombas retornam o fluxo. É o tempo sem a taxa de vazão.',
        'This is the time spent in slips and making a connection during tripping operations.':
            'É o tempo gasto nas cunhas e fazendo as conexões durante as manobras de descida/subida.',
        'The Pipe Moving Time represents the time needed for running one stand of drill pipe in or out of the hole. Actually it is the time between two slip to slip connections.':
            'Representa o tempo necessário para acontecer um estágio de drill pipe dentro ou fora do poço. É o tempo entre duas conexões slip to slip.',
        'This is the average speed the pipe is tripped in or out of the hole as a combination of pipe moving time and in slips time.':
            'É a velocidade média em que ocorre a manobra de descida ou subida do poço, uma combinação de tempo de movimentação do tubo e tempo nas cunhas.',
        'The Gross Time per Stand KPI represents the time needed for the pipe to be tripped in or out of the hole as a combination of pipe moving time and in slips time.':
            'Representa o tempo necessário para que ocorra a manobra de descida ou subida do poço, uma combinação de tempo de movimentação do tubo e tempo nas cunhas.',
        'This is the time spent in slips during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.':
            'É o tempo gasto nas cunhas durante a descida de revestimento e/ou  liner (excluindo o drill pipe!) tanto no poço aberto quanto no poço revestido.',
        'This is the average speed the joint is moved during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.':
            'É a velocidade média em que a junta é movida durante a descida do revestimento e/ou liner (excluindo o drill pipe!) tanto no poço aberto quanto no poço revestido.',
        'This KPI represents the time needed for running one joint of casing/liner into the cased hole. Actually it is the time between two casing/liner slip to slip connections.':
            'Representa o tempo necessário para descer uma junta de revestimento/liner dentro do poço revestido. É o tempo entre duas conexões casing/liner slip to slip.',
        'The KPI Gross Time per Stand represents the time needed for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time.':
            'Representa o tempo necessário para que uma junta seja manuseada dentro do poço aberto ou revestido como uma combinação de tempo de movimentação do tubo e tempo nas cunhas.',
        'This is the average speed the joint is run in the cased hole or open hole as a combination of pipe moving time and in slips time.':
            'É a velocidade média em que a junta é manuseada dentro do poço aberto ou revestido como uma combinação de tempo de movimentação do tubo e tempo nas cunhas.',
        'This is the rate for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time. Actually it is the Casing – Gross Running Speed divided by an average casing joint length.':
            'É a frequencia em que uma junta  é manuseada dentro do poço aberto ou revestido como uma combinação de tempo de movimentação do tubo e tempo nas cunhas. É a Velocidade Total de Descida dividida por um comprimento médio da junta de revestimento.',
        'Weight to Weight Minimum Flow': 'Fluxo Mínimo de Weight to Weight ',
        'Weight to Weight Minimum Flow Duration': 'Duração de Fluxo Mínima de Weight to Weight',
        'Weight to Weight Off Bottom Threshold': 'Limite Fora do Fundo de Weight to Weight',
        'Weight to Weight On Bottom Threshold': 'Limite no Fundo Weight to Weight',
        'Weight to Weight Minimum BPOS': 'Posição do Bloco Mínima de Weight to Weight ',
        'Slip to Slip Minimum HKLD': 'Carga no Gancho Mínima de Slip to Slip',
        'Slip to Slip Minimum Flow': 'Fluxo Mínimo de Slip to Slip',
        'Slip to Slip Maximum Flow': 'Fluxo Máximo de Slip to Slip',
        'Pump to Pump time': 'Tempo de Pump to Pump',
        'Weight to Weight Time': 'Tempo de Weight to Weight',
        'Weight to Slip Time': 'Tempo de Weight to Slip',
        'Slip to Slip Connection Time': 'Tempo de Conexão Slip to Slip',
        'Slip to Weight Time': 'Tempo de Slip to Weight',
        'Gross Time per Stand': 'Tempo Total por Seção',
        'Gross Drilling ROP per Stand': 'Taxa Total de Perfuração por Seção',
        'Rotating Drilling Time per Stand': 'Tempo de Perfuração Rotativa por Seção',
        'Rotating Drilling Meterage per Stand': 'Metragem de Perfuração Rotativa por Seção',
        'Rotating Drilling ROP per Stand': 'Taxa de Perfuração Rotativa por Seção',
        'Sliding Drilling Time per Stand': 'Tempo de Perfuração Orientada por Seção',
        'Sliding Drilling Meterage per Stand': 'Metragem de Perfuração Orientada por Seção',
        'Sliding Drilling ROP per Stand': ' Taxa de Perfuração Orientada por Seção',
        'Average Pipe Moving Speed': 'Média do Tempo de Movimentação do Tubo',
        'Pipe Moving Time': 'Tempo de Movimentação do Tubo',
        'Gross Running Speed': 'Velocidade Total de Descida',
        'Gross Running Rate': 'Taxa Total de Descida',
        'This is the time spent in slips and making a connection during drilling operations.':
            'É o tempo gasto em cunhas e fazendo as conexões durante as operações de perfuração.',
        'A Weight to Weight Connection represents the time between two drilled stands. This KPI starts when the drill string is lifted off from bottom and lasts until the string is on bottom drilling again.':
            'Representa o tempo entre duas seções perfuradas. É iniciado quando a coluna de perfuração é levantada do fundo e dura até que a coluna de perfuração esteja no fundo perfurando novamente.',
        'The Weight to Slips Time KPI is only calculated during a weight to weight connection. This KPI starts when the bit is lifted off bottom and lasts until the drill string is in slips.':
            'Este kpi somente é calculado durante uma conexão weight to weight. É iniciado quando a broca é levantada do fundo e dura até que a coluna de perfuração esteja nas cunhas.',
        'The Slips to Weight Time KPI is only calculated during a weight to weight connection. This KPI starts when the drill string is released out of the slips and lasts until the bit is on bottom drilling again.':
            'Este kpi somente é calculado durante uma conexão weight to weight. É iniciado quando a coluna de perfuração é solta para fora das cunhas e dura até que a broca esteja no fundo perfurando novamente.',
        'This is the time spent since the pump has been turned off until the pumps come with flow again.':
            'É o tempo gasto desde que a bomba foi desligada até que a bomba tenha fluxo novamente.',
        'This is the total time needed for drilling one stand of pipe including the weight to weight connection. Actually it covers all time from the end of a weight to weight connection until the end of the subsequent one.':
            'É o tempo necessário para perfurar uma seção de tubo, incluindo a conexão weight to weight. É todo o tempo desde o final de uma conexão weight to weight até o fim da subsequente.',
        'This KPI is calculated by dividing the drilled distance for one stand of pipe with the Drilling Gross Time KPI.':
            'Esse KPI é calculado dividindo a distância perfurada pelo valor total do tempo de uma seção',
        'The Rotating Drilling Time for one stand of pipe represents the time drilling in rotary mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g. wellbore conditioning, toolface orientation, weight to weight connections, etc.).':
            'Representa o tempo de perfuração em modo rotativo. Somente inclui o tempo no fundo e exclui qualquer parada durante a perfuração de uma seção. (e.g. condicionamento de poço, conexões weight to weight...)',
        'This is the distance per stand that was drilled in rotary mode.':
            'É a distancia por seção que foi perfurada em modo rotativo.',
        'This is the ROP per stand that was drilled in sliding mode. Actually it is calculated by dividing the Sliding Drilling Meterage with the Sliding Drilling Time.':
            'É a taxa de perfuração por seção em modo orientado. É calculado dividindo a metragem de perfuração orientada pelo tempo de perfuração orientada.',
        'The Sliding Drilling Time for one stand of pipe represents the time drilling in sliding mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g. wellbore conditioning, toolface orientation, weight to weight connections, etc.).':
            'O tempo de perfuração orientada para uma seção de tubo representa o tempo em modo de perfuração orientada. Somente inclui o tempo no fundo e exclui qualquer parada durante a perfuração de uma seção. (e.g. condicionamento de poço, conexões weight to weight...)',
        'This is the distance per stand that was drilled in sliding mode.':
            'É a distância por seção que foi perfurada em modo orientado.',
        'This is the minimum time with pump off without weight on bit.':
            'Tempo mínimo com a bomba desligada sem peso sobre broca.',
        'This is the minimum distance from the bit to the bottom, to consider that drilling has started or resumed.':
            'Distância mínima da broca em relação ao fundo, indica que que iniciou-se ou foi retomada a perfuração.',
        'This is the maximum distance from the bit to the bottom to consider that it is not drilling.':
            'Distância máxima da broca em relação ao fundo, indica que que não está havendo perfuração.',
        'This is the minimum height of the block in relation to the rotary table, to consider that it is not drilling.':
            'Altura mínima do bloco em relação a mesa rotativa, indica que que está havendo perfuração.',
        'This is the maximum residual value during connection.': 'Valor máximo residual durante conexão.',
        'KPI Options': 'Opções de KPI',
        'Stand created successfully': 'Stand criado com sucesso.',
        'Stand splitted successfully': 'Stand dividido com sucesso.',
        'Stand edit has been done successfully.': 'Edição do stand feita com sucesso.',
        'KPI delete has been done successfully.': 'KPI removido com sucesso.',
        'Failure on delete KPI. Please try again.': 'Falha ao remover KPI. Por favor, tente novamente.',
        'Failure on KPI edition.': 'Falha na edição do KPI',
        'KPI edit has been done successfully.': 'KPI editado com sucesso.',
        'Failure on stand edit. This change is not allowed.': 'Falha na edição do stand. Esta mudança não é permitida.',
        'Failure on stand delete.': 'Falha ao deletar o stand.',
        'Are you sure you want to delete the stand ': 'Tem certeza que deseja deletar o stand ',
        Reprocess: 'Reprocessar',
        'Input event type': 'Tipo do evento de entrada',
        'Output event type': 'Tipo do evento de saida',
        'Choose reprocessing span': 'Escolha o período do reprocessamento',
        'If no span is entered, "from ts 0" will be used as default':
            'Se nenhum período for selecionado, será utilizado como padrão o período: "from ts 0"',
        'Reprocessing...': 'Reprocessando...',
        'The reprocessing has finished from': 'O reprocessamento foi finalizado no periodo ',
        Expand: 'Expandir',
        Minimize: 'Minimizar',
        'Channel Reader': 'Leitor de Canais',
        'KPI Reader': 'Leitor de KPIs',
        'Slip To Sequential Time Review': 'Revisão de Tempo Sequencial',
        Filters: 'Filtros',
        'Anchor to Left': 'Fixar zoom à Esquerda',
        'Anchor to Right': 'Fixar zoom à Direita',
        'Anchor to Center': 'Fixar zoom no Centro',
        'Zoom Mode': 'Modo de Zoom',
        'Filter Channels': 'Filtrar Canais',
        'KPI Channels': 'Canais de KPI',
        'Filter Qualifier Channels': 'Filtrar Canais Qualificadores',
        'Filter visualization of qualifier channels': 'Filtrar visualização de canais qualificadores no gráfico',
        TRACK: 'TRILHA',
        'QUALIFIER CHANNELS': 'CANAIS QUALIFICADORES',
        Clear: 'Limpar',
        'Edit S2S annotations': 'Editar anotações de S2S',
        'Edit W2W annotations': 'Editar anotações de W2W',
        'Edit P2P annotations': 'Editar anotações de P2P',
        'Edit ROP annotations': 'Editar anotações de ROP',
        'Edit TRIPPING_IN annotations': 'Editar anotações de TRIPPING IN',
        'Edit TRIPPING_OUT annotations': 'Editar anotações de TRIPPING OUT',
        'Edit STAND annotations': 'Editar anotações de STAND',
        'Zoom amount': 'Quantidade de zoom',
        'Zoom in': 'Ampliar',
        'Zoom out': 'Reduzir',
        'Undo time span': 'Voltar ao período de tempo anterior',
        'Reset time span': 'Voltar ao período de tempo inicial',
        'Return initial time span': 'Retomar período de tempo anterior',
        'Return to previous time span': 'Retomar período de tempo inicial',
        'Display channels values in the chart tooltip while reading data':
            'Exibir valores de canais no leitor do gráfico',
        'Display KPIs information in the chart tooltip while reading data':
            'Exibir informações de KPIs no leitor do gráfico',
        'Backward time window': 'Janela de tempo anterior',
        'Forward time window': 'Janela de tempo seguinte',
        '3 minutes ago': 'Voltar 3 minutos',
        '3 minutes ahead': 'Avançar 3 minutos',
        'KPI NAME': 'NOME',
        'START TIME': 'INÍCIO',
        'END TIME': 'FIM',
        DURATION: 'DURAÇÃO',
        'Backward partial time window': 'Janela de tempo anterior parcial',
        'Forward partial time window': 'Janela de tempo seguinte parcial',
        'KPI SPEED': 'VELOCIDADE',
        channel: 'canal',
        channels: 'canais',
        'Are you sure you want to delete the KPI': 'Tem certeza que deseja deletar o KPI',
        'Failure creating KPI.': 'Ocorreu um erro ao criar o KPI.',
        'KPI creation has been done successfully.': 'O KPI foi criado com sucesso',
        'Failure editing KPI.': 'Ocorreu um erro ao editar o KPI',
        'KPI update has been done successfully.': 'O KPI foi atualizado com sucesso',
        "Create a Live Lookup Table with Pipes' time span values to setup your own time span presets, then set the table's macro as":
            'Crie uma Lookup Table do Live com valores de intervalos de tempo em Pipes para configurar suas próprias predefinições de tempo, em seguida defina o macro da tabela como',
        "Create a Live Lookup Table with review time values in minutes to setup your own review options, then set the table's macro as":
            'Crie uma Lookup Table do Live com valores de revisão de tempo em minutos para configurar suas próprias opções de revisão, em seguida defina o macro da tabela como',
        BROKEN_RULE_1:
            'S2S, W2W, P2P e ROP não são KPIs de Tripping! Não é possível criar um KPI de Drilling nesse stand de Tripping!',
        BROKEN_RULE_2:
            'Tripping IN/OUT não são KPIs de Drilling! Não é possível criar um KPI de Tripping nesse stand de Drilling!',
        BROKEN_RULE_3: 'S2S, ROP e Tripping IN/OUT não podem ocorrer em múltiplos Stands!',
        BROKEN_RULE_4: 'W2W e P2P sempre ocorrem entre exatamente dois Stands consecutivos!',
        BROKEN_RULE_5: 'Não podem haver múltiplas anotações do mesmo KPI em um único Stand!',
        BROKEN_RULE_6: 'Anotações de S2S, ROP e Tripping IN/OUT não podem se sobrepor!',
        BROKEN_RULE_7: 'Todas as anotações de KPI precisam de um Stand ID!',
        BROKEN_RULE_8: 'Tripping IN KPI não pode ser criado em um stand de tripping out (removal)!',
        BROKEN_RULE_9: 'Tripping OUT KPI não pode ser criado em um stand de tripping in (inclusion)!',
        INVALID_TRIPPING_DISQUALIFIED: 'KPI de tripping inválido, evento disqualified',
        ROP_KPI_MUST_BE_INSIDE_DRILLING_STAND: 'KPIs de ROP devem estar dentro de um stand de drilling',
        STAND_TYPE_EMPTY: 'Tipo de stand vazio',
        'KPI Goals saved successfully.': 'Metas de KPI gravadas com sucesso',
        'Macro Operations': 'Operações Macro',
        'Tubular run applicable goals': 'Metas aplicáveis de passagem tubular',
        'Tubular OD': 'OD Tubular',
        'Movement Direction': 'Direção do movimento',
        'Section Hole Status': 'Status da Seção do Poço',
        'Restricted Performance': 'Restrição de Performance',
        'Material Type': 'Tipo de Material',
        Unrestricted: 'Irrestrito',
        Unities: 'Unidades',
        'KPI Goals': 'Metas de KPI',
        'KPI GOALS': 'METAS DE KPI',
        'Rig Reference Value': 'Valor de referência da sonda',
        'Min Cut Off': 'Corte mínimo',
        'Max Cut Off': 'Corte máximo',
        'Stand Size': 'Tamanho do Stand',
        'Do you confirm these KPI Goals?': 'Você confirma essas metas de KPI?',
        'KPI Goals Settings': 'Configuração de Metas de KPI',
        'You need permission to edit the fields below. Contact the administrator.':
            'Você precisa de permissão para editar os campos abaixo. Entre em contato com o administrador.',
        'Invalid timespan. Resetting to default configuration.':
            'Período de tempo inválido. Redefinindo para a configuração padrão.',
        'The first timespan cannot be bigger than current date/hour. Resetting to default configuration.':
            'O primeiro intervalo de tempo não pode ser maior que a data / hora atual. Redefinindo para a configuração padrão.',
        'The start timespan cannot be bigger than end timespan.':
            'O tempo de início não pode ser maior que o tempo final.',
        "Can't fetch Standard Channels from Live.": 'Não foi possível carregar os Canais Padrão do Live.',
        'Are you sure you want to dismiss this event? The alert will be permanently deleted.':
            'Tem certeza de que deseja descartar este evento? O alerta será excluído permanentemente.',
        DISMISS: 'DESCARTAR',
        'KPI’s start edge.': 'Borda inicial do KPI',
        ' alerts without review': ' alertas sem revisão',
        ' alert without review': ' alerta sem revisão',
        'No alerts for review': 'Não existem alertas para revisão',
        'Take me there': 'Leve-me lá',
        Dismiss: 'Descartar',
        'Review panel': 'Painel de revisão',
        'There is a pending review of reprocessed event at': 'Há uma revisão pendente do evento reprocessado em',
        at: 'às',
        intervention: 'intervenção',
        'section / phase': 'seção / fase',
        'rig table status': 'status da mesa rotativa',
        runs: 'corrida',
        'tubular type': 'tipo tubular',
        'create event': 'criar evento',
        'start new section / phase': 'iniciar nova seção / fase',
        'Select an option': 'Selecione uma opção',
        inches: 'polegadas',
        in: 'pol',
        Confirm: 'Confirmar',
        'Outside Diameter (OD)': 'Diâmetro Externo (OD)',
        'Beginning Measured Depth (MD)': 'Profundidade Inicial (MD inicial)',
        'Final Measured Depth (MD)': 'Profundidade Final (MD final)',
        'Begin Date': 'Data Inicial',
        'End Date': 'Data Final',
        Time: 'Horário',
        Reason: 'Motivo',
        Critical: 'Crítico',
        'Select a status': 'Selecione o status',
        'Select a type': 'Selecione o tipo',
        RpiRelevantPath: 'Trajeto Relevante RPI',
        RPINonRelevantPath: 'Trajeto Não Relevante RPI',
        Main: 'Principal',
        Auxiliary: 'Auxiliar',
        Day: 'Diurno',
        Night: 'Noturno',
        Schedule: 'Cronograma',
        'required field': 'campo obrigatório',
        'Previous Casing Final OD': 'OD Final Anterior',
        'Previous Casing Final MD': 'MD Final Anterior',
        Crew: 'Equipe',
        'Select a shift': 'Selecione o turno',
        REAL_TIME_AGGREGATION_WARNING:
            'A compressão de dados em tempo real está desligada. Nenhum novo dado comprimido está sendo gerado.',
        'Select the KPIs of interest.': 'Selecione os KPIs de interesse.',
        'No KPI selected': 'Nenhum KPI selecionado',
        'KPI(s) selected': 'KPI(s) selecionado(s)',
        "Can't fetch KPI indicators parameters.": 'Não foi possível carregar parâmetros de indicadores KPI.',
        "Can't fetch user's selected KPI parameters.":
            'Não foi possível carregar os parâmetros de indicadores KPI selecionados do usuário.',
        "Can't save KPI parameters.": 'Não foi possível salvar os parâmetros de indicadores KPI.',
        'Default KPI parameters was applied.': 'Parâmetros de indicatores KPI padrão foi aplicado.',
        "Can't apply KPI parameters.": 'Não foi possível aplicar os parâmetros de indicatores KPI.',
        'Select the KPIs of interest by stand type.': 'Selecione os KPIs de interesse pelo tipo de Stand.',
        'Are you sure you want delete this KPI goal?': 'Tem certeza que deseja remover essa meta de KPI?',
        Goal: 'Meta',
        'Confirm deletion': 'Confirmar exclusão',
        'You can swap just a goal for time.': 'Você só pode trocar uma meta por vez.',
        'Tubular Activies': 'Atividades Tubulares',
        'Swap Goals': 'Alterar Metas',
        'Save KPI Goal': 'Salvar metas de KPI',
        'Import Global KPI Goal': 'Importar meta de KPI global',
        'Customize Imported Goals': 'Customizar metas importadas',
        'Add KPI Goal': 'Adicionar metas de KPI',
        'Delete goal to this rig': 'Deletar meta para esta sonda',
        'Edit goal to this rig': 'Editar meta para esta sonda',
        'Total Stand Time KPI': 'Tempo total do Stand KPI',
        'tst-off': 'desligado',
        'tst-on': 'ligado',
        'This feature allows you to create a Total Stand Time goal. To turn this feature on or off, go to KPI Configuration, choose KPI Goals Settings and the Tripping operation macro.':
            'Este recurso permite que você crie uma meta de tempo total de Stand. Para ativar ou desativar esse recurso, vá para Configurações de KPI, escolha Configuração de Metas de KPI e a macro operação Manobra.',
        'Swap to the selected goal': 'Trocar para a meta selecionada',
        'Add selected KPI goals on the rig': 'Adicionar metas de KPI selecionadas na sonda',
        'Select a goal from global goals list to use on this rig':
            'Selecione uma meta da lista de metas globais para usar nesta sonda',
        'Swap current goal to another on KPI goal global list':
            'Alterar a meta atual para outra da lista de metas globais',
        'Goals swapped successfully.': 'Metas alteradas com sucesso.',
        'Bit Depth values are automatically loaded. If they are empty, you must fill them.':
            'Os valores de Bit Depth são automaticamente carregados. Se estiverem vazios, você deve preenche-los',
        'Hole Depth values are automatically loaded. If they are empty, you must fill them.':
            'Os valores de Hole Depth são automaticamente carregados. Se estiverem vazios, você deve preenche-los',
        'No Goals saved for this Tubular Type...': 'Não há metas salvas para esse tipo de tubular.',
        'Please fill all fields': 'Por favor, preencha todos os campos',
        'Delay Automatic Detection of KPIs': 'Atrasar a Detecção Automática de KPIs',
        'Time delay': 'Tempo de atraso',
        'The value filled in this field corresponds to the delay time (in minutes) that will be applied on the Automatic Detection of KPIs, to correct the KPI classification. This value will apply to all Rigs as global setting.':
            'O valor preenchido neste campo corresponde ao tempo de atraso (em minutos) que será aplicado na Detecção Automática de KPIs, para corrigir a classificação dos KPIs. Este valor será aplicado a todas as sondas como configuração global.',
        'KPI delay saved successfully.': 'Atraso de KPI salvo com sucesso.',
        'Applies a delay in the automatic detection of KPIs in minutes, for all assets where it is possible to generate KPIs waiting for a buffer time, avoiding losing events that are eventually received out of order.':
            'Aplica um atraso na detecção automática de KPIs em minutos, para todos os ativos em que seja possível gerar KPIs esperando um tempo de buffer, evitando perder eventos eventualmente recebidos fora de ordem.',
        'A value of 0 minute makes real-time automatic detection of runtime/receipt KPIs. Although it is possible, it is not recommended, as data from channels that generate KPIs received out of order at runtime can result in the generation of KPIS with low quality/assertivity and high oscillation of rig state.':
            'Um valor de 0 minuto, torna em tempo real a detecção automática de KPIs em tempo de execução/recebimento de dados. Embora seja possível, não é recomendável, já que dados de canais que geram KPIs recebidos fora de ordem em tempo de execução, podem resultar na geração de KPIS com baixa qualidade/assertividade e alta oscilação de estados de sonda (rig state).',
        'NOTE: The delay will be counted in each operation cycle, all rigstates, stands and KPIs contained in a *closed* stand (KPIs have a detection delay of at least 1 stand); therefore, in long constant operations, such as drilling, which can take hours to complete without changing the rigstate, there may be a delay of hours from the completion of the current operation, added to the delay time for the detection to be completed.':
            'OBS: O atraso será contabilizado a cada ciclo de operação, todos os rigstates, stands e KPIs contidos em um stand *fechado* (KPIs possuem atraso de deteção de ao menos 1 stand); sendo assim, em operações constantes longas, como por exemplo, drilling, que pode levar horas para finalizar sem mudança de rigstate, poderá haver atraso de horas da finalização da operação vigente, adicionado ao tempo de atraso para que a detecção seja finalizada.',
        'Realtime Rig State Channels Configuration': 'Configuração de Canais em Tempo Real dos Estados da Sonda',
        'Rig State Channels Realtime Configuration': 'Configuração de Canais em Tempo Real dos Estados da Sonda',
        'Customize for Reprocessing': 'Customizar para Reprocessamento',
        'Rate of Penetration': 'Taxa de Penetração',
        'Block Position': 'Posição do Bloco',
        'Weight on Bit': 'Peso sobre a broca',
        'SPP Pressure': 'Pressão SPP',
        'Surface Torque': 'Torque de Superfície',
        'Mud Flow In': 'Fluxo de Entrada de Lama',
        Hookload: 'Carga de Gancho',
        'Surface RPM': 'RPM da Superfície',
        'Rig State Channels for Reprocessing': 'Canais de Estado da Sonda para Reprocessamento',
        'New KPI Goal': 'Nova Meta de KPI',
        'Swap KPI Goals': 'Trocar Metas de KPI',
        // Import/Export KPI Goals CSV
        Operation: 'Operação',
        Unit: 'Unidade',
        Goals: 'Metas',
        'Import KPI Goals': 'Importar Metas de KPI',
        'Export KPI Goals': 'Exportar Metas de KPI',
        Import: 'Importar',
        Export: 'Exportar',
        Row: 'Linha',
        'Choose which operations to include in the export.': 'Escolha quais operações incluir na exportação.',
        'New goals to create': 'Novas metas a criar',
        'Existing goals matched by code': 'Metas existentes encontradas pelo código',
        'Rows with errors (will be skipped)': 'Linhas com erros (serão ignoradas)',
        'Some rows matched the code of an existing goal. What should we do?':
            'Algumas linhas correspondem ao código de uma meta já existente. O que devemos fazer?',
        'Update the existing goals with the imported values': 'Atualizar as metas existentes com os valores importados',
        'Skip rows that match an existing goal': 'Ignorar linhas que correspondem a uma meta existente',
        'more errors': 'mais erros',
        'The file has no rows to import.': 'O arquivo não possui linhas para importar.',
        'The file is empty.': 'O arquivo está vazio.',
        'KPI Goals configuration is not loaded yet.': 'A configuração de Metas de KPI ainda não foi carregada.',
        Expected: 'Esperado',
        'columns but found': 'colunas, mas foram encontradas',
        'Missing attribute value in column': 'Valor de atributo ausente na coluna',
        'Could not match attribute': 'Não foi possível encontrar o atributo',
        'Could not match operation': 'Não foi possível encontrar a operação',
        'in column': 'na coluna',
        'Tubular range values must be numbers.': 'Os valores de intervalo tubular devem ser números.',
        'Value for': 'O valor de',
        'must be a number.': 'deve ser um número.',
        'Import finished': 'Importação finalizada',
        created: 'criadas',
        updated: 'atualizadas',
        skipped: 'ignoradas',
        failed: 'falharam',
        'Customize Rig State Channels for Reprocessing': 'Customizar Canais do Estado da Sonda para Reprocessamento',
        'Real time': 'Tempo Real',
        'KPI SERVICE': 'SERVIÇO DE KPI',
        'Macro Operation': 'Operação Macro',
        History: 'Histórico',
        'SELECTED CHANNELS': 'CANAIS SELECIONADOS',
        'Select KPI channel': 'Selecionar canal de KPI',
        'Add channel': 'Adicionar canal',
        'Restore Chart Defaults': 'Restaurar padrão',
        'Custom color': 'Escolher cor',
        'Attention!': 'Atenção!',
        'When you select a new asset as a data source, realtime service is automatically turned off, and it can be turned back on right after choosing the new asset.':
            'Quando você selecionar um novo ativo como fonte de dados, o serviço em tempo real é automaticamente desativado e pode ser reativado logo após a escolha do novo ativo.',
        'Do you want to select a new asset as a data source source?':
            'Você deseja selecionar um novo ativo como fonte de dados?',
        'RigState Channels Configuration': 'Configuração dos Canais de RigState',
        'RigState Channels Settings': 'Configuração dos Canais de RigState',
        'Channels and Parameters saved successfully. Kpi realtime generation will be reloaded...':
            'Canais e parâmetros salvos com sucesso. Geração de KPI em tempo real vai ser recarregada...',
        'Channels saved successfully. Kpi realtime generation will be reloaded...':
            'Canais salvos com sucesso. Geração de KPI em tempo real vai ser recarregada...',
        'This will reload the KPI service and restart all Realtime KPI generations.':
            'Isso recarregará o serviço KPI e reiniciará todas as gerações de KPI em tempo real.',
        CHANNEL: 'CANAL',
        INTERPOLATION: 'INTERPOLAÇÃO',
        'FREQUENCY OF INTERPOLATION': 'FREQUÊNCIA DE INTERPOLAÇÃO',
        'MAXIMUM DELTA TIME TO NOT INTERPOLATE': 'TEMPO MÁXIMO DE DELTA PARA NÃO INTERPOLAR',
        sec: 'seg',
        'Mandatory completion': 'Preenchimento obrigatório',
        'Required field': 'Campo obrigatório',
        'Required Field': 'Campo obrigatório',
        'Would you like to start realtime service from last valid span':
            'Gostaria de reiniciar o serviço de tempo real do último período de tempo válido?',
        YES: 'Sim',
        // TODO start: KPIs Input Event Type Override
        'KPI Event Type Settings': 'Configurações de Tipo de Evento',
        'Define the suffix for the KPI event type name. This suffix is chained to the event type name of each rig. The default collection name is always {event_type_name}_{this-suffix}.':
            'Define um sufixo para o tipo de evento de KPI. Este sufixo é adicionado ao nome do tipo de evento de cada sonda. O nome padrão da coleção é sempre {event_type_name}_{este-sufixo}.',
        "This value can be changed individually for each asset, allowing different assets to use different event types depending on operational or integration needs. Access the rig's KPI Options tab to change this value to suit your specific needs.":
            'Este valor pode ser modificado individualmente para cada ativo, permitindo que ativos diferentes utilizem diferentes tipos de evento conforme as necessidades operacionais ou de integração. Acesse a aba Opções de KPI da sonda para para ajustar esse valor de acordo com suas necessidades específicas.',
        'Default KPI event type suffix': 'Sufixo padrão para tipo de evento de KPI',
        'The defined value will be applied by default to all rigs. This setting can be overridden individually on each rig, allowing you to change the event type source to the one defined locally in Data Management or, if necessary, manually customize a unique suffix for the rig.':
            'O valor definido será aplicado por padrão a todas as sondas. Esta configuração pode ser alterada individualmente em cada sonda, permitindo que você altere o tipo de evento de origem pelo definido localmente na Gestão de Dados ou, se necessário, customizar manualmente um sufixo específico para a sonda.',
        'Important: Changing this setting affects both real-time processing and reprocessing on all rigs that use this default setting. For a new value to be applied, you need to restart the plugin-kpis-drilling plugin.':
            'Importante: Alterar esta configuração afeta o processamento em tempo real e o reprocessamento em todas as sondas que usam esta configuração padrão. Para um novo valor ser aplicado, você precisa reiniciar o plugin-kpis-drilling.',
        'KPI Event Type settings saved successfully.': 'Configurações de Tipo de Evento salvas com sucesso.',
        'NOTE: For the change to apply to both real-time and reprocessing, you need to restart the plugin-kpis-drilling plugin.':
            'OBS: Para a modificação ser aplicada ao processamento em tempo real e ao reprocessamento, você precisa reiniciar o plugin-kpis-drilling.',
        'Default KPI event type': 'Tipo de evento de KPI padrão',
        'Rig event type': 'Tipo de evento da sonda',
        'Custom KPI event type': 'Tipo de evento de KPI customizado',
        'KPI event type': 'Tipo de evento de KPI',
        'Input event type source': 'Origem do tipo de evento de entrada',
        'Select the source of the input event type to generate KPIs:':
            'Selecione a origem do tipo de evento de entrada para gerar KPIs:',
        "Default KPI event type: uses a default suffix defined in KPI Configuration, concatenated to the rig's event type.":
            'Tipo de evento de KPI padrão: usa um sufixo padrão definido em Configuração de KPI, concatenado ao tipo de evento da sonda.',
        'Rig event type: uses the event type defined locally for the rig in Data Management, without the KPI suffix.':
            'Tipo de evento de KPI: usa o tipo de evento definido localmente para a sonda na Gestão de Dados, sem um sufixo adicional.',
        'Custom event type: allows you to manually enter a unique suffix for the rig, different from the global default, which will be concatenated to the event type defined in Data Management.':
            'Tipo de evento de KPI customizado: permite que você entre manualmente com um sufixo específico para a sonda, diferente do padrão global, que será concatenado ao tipo de evento definido na Gestão de Dados.',
        'Input event type name': 'Nome do tipo de evento de entrada',
        "The default global configuration was recently changed and is not yet reflected in this rig's real-time processing or reprocessing. The plugin-kpis-drilling must be restarted to apply the changes.":
            'A configuração global padrão foi modificada recentemente e ainda não foi aplicada ao processamento em tempo real ou ao reprocessamento desta sonda. O plugin-kpis-drilling precisa ser reiniciado para aplicar a nova configuração.',
        'The default value is outdated. Restart the plugin-kpis-drilling to apply the new configuration to real-time and reprocessing.':
            'O valor padrão está desatualizado. Reinicie o plugin-kpis-drilling para aplicar o novo valor ao tempo real e reprocessamento.',
        // TODO end: KPIs Input Event Type Override
        'KPI Compressed Settings': 'Configurações de KPI Compactado',
        'Log Settings of KPIs': 'Configurações de Logs do KPI',
        'Compressed Time Settings': 'Configuração do Tempo Compactado',
        'Uncompressed Time': 'Tempo descompactado',
        'Advanced KPI Logs': 'Logs Avançados do KPI',
        'KPI Logs was updated successfully.': 'Logs de KPI foram atualizados com sucesso.',
        'Are you sure you want to change the settings?': 'Tem certeza de que deseja alterar as configurações?',
        'Events Compress was updated successfully.': 'Compressão de Eventos foi atualizada com sucesso.',
        'Static Data and Annotation Tool widgets need compressed events (generated with _compress suffix) for viewing channel data.':
            'Os widgets Static Data e Annotation Tool precisam de eventos compactados (gerados com sufixo _compress) para visualizar os dados de canais.',
        'Disabling this toggle removes queries used to compress channels data for all rigs and wells on the tab Data Aggregations on each rig. The compressed events have the suffix _compress. Be aware that it will override any event with the same name.':
            'Desabilitar este campo remove queries para compressão de canais de dados para todos as Sondas e Poços. Estes eventos comprimidos possuem o sufixo _compress. Esteja ciente que eles irão sobrescrever qualquer outro evento com mesmo nome e sufixo.',
        'Enable this toggle will make KPI Realtime and Reprocessing start to generate a lot of logs.info. Those logs can become a burden in the long run. Please, use with caution.':
            'Habilitar este campo fará com que os KPIs de Tempo Real e Reprocessamento gere mais muito mais logs que o normal. Estes logs podem se tornar uma sobrecarga a longo prazo. Por favor, use com cautela.',
        'Alert: Use this feature only for bug investigations purpose. Remember to always deactivate after investigation ends.':
            'Alerta: Use esta funcionalidades apenas para propósito de investigação de bugs. Lembre-se de sempre desativar após terminar a investigação.',
        'Alert: Static Data and Annotation Tools widgets needs events that has been generated with _compress suffix to enable channel data visualization.':
            'Alerta: os widgets Static Data e Annotation Tool precisam de eventos que possuam o sufixo _compress para visualização de dados de canais.',
        'Events compression': 'Compressão de eventos',
        'If you change Uncompressed Time, it will reset the period to be visualized with uncompressed channel data in the Annotation Tool and Temporal Chart in 24h dashboard Widgets.':
            'Se você mudar o Tempo Descompactado, então isso redefinirá o período a ser visualizado com dados de canal não compactados no widget Ferramenta de Anotação e no Dashboard 24h.',
        now: 'agora',
        'Restore Default': 'Restaurar padrão',
        'The value filled in this field corresponds to the time (in hours) that will be applied to channels selected in the Annotation Tool and Temporal Chart in 24h dashboard Widgets, to toggle uncompressed to compressed channel base.':
            'O valor preenchido neste campo corresponde ao tempo (em horas) que será aplicado aos canais selecionados na Ferramenta de Anotação e no Gráfico Temporal nos widgets do Dashboard 24h, para alternar de base de canais descompactada para compactada.',
        'Since the Annotation Tool and Temporal Chart in 24h dashboard Widgets expects real time compressed channel data, if span is larger than 6 hours, the selection of any alternative channel that is not in the real time KPIs list will result in a blank channel.':
            'Como o widget Ferramenta de Anotações e o Gráfico Temporal no Dashboard 24h esperam dados de canal compactados em tempo real, se o intervalo for maior que 6 horas, a seleção de qualquer canal alternativo que não esteja na lista de KPIs em tempo real, resultará em um canal em branco.',
        'To overcome this issue, this option will able to configure how many hours the user wants to switch from compressed to uncompressed base on Annotation Tool Widget or 24h Dashboard.':
            'Para contornar esse problema, esta opção poderá configurar quantas horas o usuário deseja alternar de base compactada para descompactada no widget Ferramenta de Anotação ou no Dashboard 24h.',
        'Attention!': 'Atenção!',
        'Uncompressed Time was created successfully.': 'O tempo descompactado foi criado com sucesso.',
        'Are you sure you want to save configuration? This will change the saved channels when creating or editing next kpis':
            'Tem certeza que deseja salvar as configurações? Isso irá alterar os canais salvos quando criar ou editar os próximos kpis.',
        'ATW KPI Channels': 'Canais de KPI no ATW',
        CONFIRM: 'CONFIRMAR',
        NO: 'NÃO',
        'There is a different rig in the reprocess period you selected. If you reprocess this period using the present rig, it will overwrite the information as if it were done with the present rig.':
            'Existe uma sonda diferente no período de reprocessamento selecionado. Se você reprocessar este período usando a sonda atual, ele sobrescreverá as informações como se tivesse sido feita com a sonda atual.',
        'There are events generated for: ': 'Existem eventos gerados para: ',
        'Do you want to select this period anyway?': 'Deseja selecionar esse período mesmo assim?',
        'in the period from': 'no periodo de',
        to: 'até',
        'Select a well to active real time.': 'Selecione um well para ativar o tempo real.',
        'Apply reprocess': 'Aplicar reprocessamento',
        'Rig associated with Well: ': 'Sonda associada ao poço: ',
        'To enable realtime processing in the present configuration, you must turn off real time in the ':
            'Para habilitar o processamento em tempo real na presente configuração, você deve desligar o tempo real no ',
        'the following channels were utilized to generate KPIs': 'os seguintes canais foram utilizados para gerar KPIs',
        'KPI Channel': 'Canal KPI',
        'KPI channels on period.': 'Canais no período.',
        'Error when start reprocessing.': 'Erro ao iniciar o reprocessamento.',
        'Please, fill a period to reprocess!': 'Por favor, preencha um período para reprocessar!',
        "Couldn't get data on period": 'Não existem dados no período.',
        'Max delay value is 1440 minutes (1 day).': 'O valor máximo de atraso é de 1440 minutos (1 dia).',
        'Max compressed time value is 240 hours (10 days).': 'O valor máximo de atraso é de 240 horas (10 dia).',
        'Datasource origin': 'Origem da fonte de dados',
        'If you select well as data source, it will cause KPIs to be generated from the collection of normalized channels of selected well.':
            'Se você selecionar o poço como fonte de dados, isso fará com que os KPIs sejam gerados a partir da coleção de canais normalizados do poço selecionado.',
        'All Wells': 'Todos os poços',
        'Wells with active interventions': 'Poços com intervenção ativa',
        'Select a well to active real time': 'Selecione um poço para ativar o tempo real',
        'The span must be less than 60 days.': 'O período deve ser menor que 60 dias.',
        'The expanded span must be less than 90 days.': 'O período estendido deve ser menor que 90 dias.',
        'Please wait to change the asset, we are pre-loading some data from ':
            'Por favor aguarde para alterar o ativo, estamos pré carregando alguns dado de ',
        'Select data source': 'Selecionar dado',
        'Histogram Data Source': 'Dados do Histograma',
        'Histogram will be generated from a single selected data source.':
            'O histograma será gerado a partir de uma única fonte de dados selecionada.',
        'GOAL / KPI / Channel': 'GOAL / KPI / Channel',
        Settings: 'Configurações',
        'Realtime cannot start because the selected well':
            'O tempo real não pode ser iniciado porque o poço selecionado',
        'is being processed with the same event type': 'está sendo processado com o mesmo tipo de evento',
        'in another Rig': 'em outro Rig',
        'You must stop Realtime from the other Rig or change the name of the event type in':
            'Você deve interromper o tempo real do outro Rig ou alterar o nome do tipo de evento em ',
        'Data Management': 'Gestão de Dados',
        'It is not possible to generate KPI in Realtime because the selected Well':
            'Não é possível gerar KPI em Realtime pois o Poço selecionado',
        'already is associated with another Rig': 'já está associado a outra sonda',
        'To enable Realtime processing in the present configuration, you must turn off Realtime in the':
            'Para ativar o processamento em tempo real na configuração atual, você deve desativar o tempo real na ',
        'Box Plot will be generated from a single selected data source.':
            'O boxplot será gerado a partir de uma única fonte de dados selecionada.',
        'Boxplot Data Source': 'Dados do Boxplot',
        'Second Quantile': 'Segundo Quantil',
        'First Quantile': 'Primeiro Quantil',

        // ML Screen KPI Options
        'KPI Datasource': 'Fonte de Dados KPI',
        'Data Aggregations': 'Agregações de Dados',
        'interpolation-on': 'LIGADO',
        'interpolation-off': 'DESLIGADO',
        'realtime-aggregation-on': 'LIGADO',
        'realtime-aggregation-off': 'DESLIGADO',
        'The aggregator is used to compress Rig or Well data, being important for viewing channels in KPI dashboards. Enable Realtime compression on Data Aggregations tab of the asset (Rig or Well) chosen to generate KPI.':
            'O agregador é utilizado para comprimir dados da Sonda ou Poço, sendo importante para visualização de canais em dashboards de KPI. Habilite a compressão em Tempo Real na aba Agregações de Dados do ativo (Sonda ou Poço) escolhido para gerar o KPI.',
        'Datasource Origin': 'Origem da Fonte de Dados',
        'Input Event Type': 'Tipo de Evento de Entrada',
        'Output Event Type': 'Tipo de Evento de Saída',
        'Real Time KPI Channels': 'Canais de KPI em Tempo Real',
        'KPI GENERATION METHODOLOGY': 'METODOLOGIA DE GERAÇÃO DE KPI',
        "You need to configure Physical Models to generate Rig State events. This setting will affect the generation of KPI data, both in the 'KPI Detector by Rig States' and 'Adaptive KPI Detector (ML - Machine Learning)' methodology.":
            "Você precisa configurar modelos físicos para gerar eventos Rig State. Esta configuração afetará a geração de dados de KPI, tanto na metodologia 'KPI Detector by Rig States' quanto na 'Adaptive KPI Detector (ML - Machine Learning)'.",
        'EVENT SPAN': 'PERÍODO DO EVENTO',
        'Channels configurations': 'Configurações de canais',
        'Last started on': 'Último iniciado em',
        'Real Time will start from the beginning of the last detected stand. Real Time reprocessing period considers a maximum of 2 days backwards.':
            'O Tempo Real começará a partir do início do último estande detectado. O período de reprocessamento em Tempo Real considera no máximo 2 dias para trás.',
        none: 'nenhum',
        'No Process': 'Nenhum processo',
        'Checking status...': 'Verificando o estado...',
        Running: 'Em execução',
        Error: 'Erro',
        Initializing: 'Inicializando',
        'Initializing Real Time may take a few minutes.':
            'O processamento em Tempo Real pode demorar alguns minutos para iniciar',
        'Initializing Reprocessing may take a few minutes.':
            'O reprocessamento pode demorar alguns minutos para iniciar',
        Disconnecting: 'Desconectando...',
        Disconnected: 'Desconectado',
        'Realtime was abruptly disconnected. You need to stop Realtime':
            'Tempo real foi desconectado abruptamente. Você precisa parar a geração em tempo real',
        Start: 'Iniciar',
        Stop: 'Parar',
        'No KPI data being generated.': 'Nenhum dado de KPI sendo gerado.',
        'No KPI data being reprocessed.': 'Nenhum dado de KPI sendo reprocessado.',
        'Choose reprocessing span': 'Escolha o período de reprocessamento',
        'Choose span': 'Escolha o período',
        'No Reprocess': 'Sem Reprocessar',
        'Generating KPI data.': 'Gerando dados de KPI.',
        'An error has occurred. You need to restart Real Time processing.':
            'Ocorreu um erro. Você precisa reiniciar o processamento em tempo real.',
        'An error has occurred. You need to stop Reprocessing.':
            'Ocorreu um erro. Você precisa parar o reprocessamento.',
        'An error has occurred and Real Time processing cannot be started.':
            'Ocorreu um erro e o processamento em tempo real não pode ser iniciado.',
        'An error has occurred and Reprocessing cannot be started.':
            'Ocorreu um erro e o reprocessamento não pode ser iniciado.',
        'The reprocessing of asset KPI data has stopped.':
            'O reprocessamento de dados de KPI do Asset foi interrompido.',
        'Asset KPI data generation has completed successfully.':
            'A geração de dados de KPI do Asset foi concluída com sucesso.',
        'All KPI data in the selected period will be replaced with new reprocessed data.':
            'Todos os dados de KPI no período selecionado serão substituídos por novos dados reprocessados.',
        'Stopping reprocessing will cause the selected KPI data period to become incomplete.':
            'A interrupção do reprocessamento fará com que o período de dados do KPI selecionado fique incompleto.',
        'Are you sure you want to complete this action?': 'Tem certeza de que deseja concluir esta ação?',
        "It's not possible to configure channels while Real Time is Running. You need to stop Real Time to access Channels Configurations.":
            'Não é possível configurar canais enquanto o Tempo Real estiver rodando. Você precisa parar o Tempo Real para acessar as Configurações dos Canais.',
        "It's not possible to configure channels while Reprocessing. You need to stop Reprocessing or wait for it to finish to access Channels Configurations.":
            'Não é possível configurar canais durante o Reprocessamento. Você precisa parar o Reprocessamento ou esperar que ele termine para acessar as Configurações dos Canais.',
        'Tubular will be finished with changes applied to tubular type and/or restricted performance':
            'O tubular será finalizado com a alteração feita no tipo tubular e/ou desempenho restrito',
        'Are you sure you want to update and finish the tubular event':
            'Você tem certeza que deseja alterar e finalizar este tubular',
        'Reprocessing KPI Channels': 'Reprocessamento de Canais de KPI',
        "It's not possible to reprocess the chosen period. There is a stand being processed on realtime. It's possible to reprocess until":
            'Não é possível reprocessar o período solicitado. Existe um stand sendo processado em tempo real. No momento é possível reprocessar até',
        'No data period at the selected span': 'Nenhum período de dados no intervalo selecionado',
        'Failed to initialize Rig state query.': 'Falha ao inicializar a consulta de estado da sonda.',
        'Failed to initialize StateMachineManager: The provided data provider is invalid or null.':
            'Falha ao inicializar StateMachineManager: o provedor de dados fornecido é inválido ou nulo.',
        'Failed to create the StateMachineManager: Issues related to the state machine or event lobby.':
            'Falha ao criar o StateMachineManager: problemas relacionados à máquina de estado ou ao lobby do evento.',
        'Failed to create the StateMachineManager: Invalid output collection.':
            'Falha ao criar o StateMachineManager: coleção de saída inválida.',
        'Could not validate if has channels data on this period':
            'Não foi possível validar se possui dados de canais neste período',
        'Could not convert span to user timezone':
            'Não foi possível converter o intervalo para o fuso horário do usuário',
        CHANNELS: 'CANAIS',
        'Pup Joint was saved successfully.': 'Pup Joint salvo com sucesso.',
        'Pup Joint Detection Settings updated successfully':
            'As configurações de detecção Pup Joint foram atualizadas com sucesso',
        // Riser Rig State Presets (OGP21-5070..5072, PR #1755) — finding 9 / ação A-9
        'The selected channel has an invalid mnemonic and cannot be used.':
            'O canal selecionado tem um mnemônico inválido e não pode ser usado.',
        'Rig State Presets': 'Rig State Presets',
        'Standard Preset': 'Preset Standard',
        'Riser Preset': 'Preset Riser',
        'Riser Indicator Channel': 'Canal Indicador de Riser',
        'Select a standard preset': 'Selecione um preset standard',
        'Select a riser preset': 'Selecione um preset riser',
        'Select a binary channel': 'Selecione um canal binário',
        'No Standard Preset selected — select one to be used when the Riser indicator channel is inactive or unmapped.':
            'Nenhum Preset Standard selecionado — selecione um para ser usado quando o canal indicador de Riser estiver inativo ou não mapeado.',
        'No Standard Preset selected — select one to enable rig status detection.':
            'Nenhum Preset Standard selecionado — selecione um para habilitar a detecção de rig state.',
        'Without Riser Preset — detection will only use the Standard Preset.':
            'Sem Preset Riser — a detecção usará apenas o Preset Standard.',
        'No channel mapped — operates with Standard Preset.': 'Nenhum canal mapeado — opera com o Preset Standard.',
        'No channel mapped — select one to activate Preset Riser and enable automatic switching between presets.':
            'Nenhum canal mapeado — selecione um para ativar o Preset Riser e habilitar a troca automática entre presets.',
        'Preset applied by default in rig state detection. It will be used whenever the Riser indicator channel is inactive, null, unmapped, or not configured.':
            'Preset aplicado por padrão na detecção de rig state. Será usado sempre que o canal indicador de Riser estiver inativo, nulo, não mapeado ou não configurado.',
        'Preset applied when the Riser indicator channel signals Riser operation. Requires a mapped indicator channel to enable automatic switching.':
            'Preset aplicado quando o canal indicador de Riser sinaliza operação de Riser. Requer um canal indicador mapeado para habilitar a troca automática.',
        'Binary channel (0/1) indicating riser operation. Displays only binary channels mapped in the Channel Manager of this rig.':
            'Canal binário (0/1) que indica operação de riser. Exibe apenas canais binários mapeados no Channel Manager desta sonda.',
        'Automatic mode active — switching between Standard Preset and Riser according to the indicated channel.':
            'Modo automático ativo — alternando entre Preset Standard e Riser conforme o canal indicado.',
        'Riser Preset not selected.': 'Preset Riser não selecionado.',
        'No Riser Channel (using Standard Preset).': 'Sem Canal de Riser (usando o Preset Standard).',
        'Auto-switch active': 'Troca automática ativa',
        'Select a Standard Preset before applying.': 'Selecione um Preset Standard antes de aplicar.',
        'The selected preset no longer exists on this rig. Reload the page and try again.':
            'O preset selecionado não existe mais nesta sonda. Recarregue a página e tente novamente.',
        'Standard Preset and Riser Preset must be different presets.':
            'O Preset Standard e o Preset Riser devem ser presets diferentes.',
        'The selected channel is not a binary (0/1) channel.': 'O canal selecionado não é um canal binário (0/1).',
        'The selected channel is not mapped in the Channel Manager of this rig.':
            'O canal selecionado não está mapeado no Channel Manager desta sonda.',
        'Could not save the Rig State Presets configuration.':
            'Não foi possível salvar a configuração de Rig State Presets.',
        'Rig State Presets updated successfully': 'Configurações de Rig State Presets atualizadas com sucesso',
        'This change affects reprocessing. Restart the plugin-kpis-drilling to use it in Real Time as well.':
            'Esta alteração afeta o reprocessamento. Reinicie o plugin-kpis-drilling para usar em tempo real.',
        'Value (%) that defines the minimum pipe length to be considered to create Stand Single. The default value applied for calculation corresponds to 80% of the pipe length.':
            'O valor (%) define o comprimento mínimo da tubulação a ser considerado para criação do Stand Single. O valor padrão aplicado para cálculo corresponde a 80% do comprimento do tubo.',
        'Minimum Stand Size': 'Tamanho Minimo do Estande',
        'of Pipe Length': 'em Comprimento Pipe',
        'Changes will only be applied to reprocessing made from now on. To apply this new configuration also in Real Time, it is necessary to restart the plugin-kpis-drilling.':
            'As alterações serão aplicadas apenas aos reprocessamentos feitos a partir deste momento. Para aplicar esta configuração também em Tempo Real, é necessário reiniciar o plugin-kpis-drilling.',
        'Determines whether or not a stand is created when the delta bit depth between two Rig State Connection is less than or equal to the Minimum Stand Size.':
            'Determina se um estande é ou não criado quando a profundidade de bit depth entre duas conexões de Rig State é menor ou igual ao tamanho mínimo do estande.',
        'Enable this toggle to create Pup Joint Stand Size by Minimum Stand Size or disable to skip creation of this new stand.':
            'Habilite este toggle para criar o tamanho do estande de Pup Joint pelo tamanho mínimo ou desative para pular a criação.',
        'Compression Settings': 'Configuração de Compressão',
        'Disabling this toggle will turn off channel compression in the "KPI RIG STATE CHANNELS" widget on the 24h dashboard by disabling the pipes module @@assetWidgetOverrideFilter. Also it may break any widget and functionality that uses it.':
            'Desabilitar esta toggle irá desligar a compressão de canais no widget "KPI RIG STATE CHANNELS" no dashboard de 24h desativando o módulo pipes @@assetWidgetOverrideFilter. Além disso, também poderá quebrar qualquer widget e funcionalidade que use este módulo Pipes',
        'You must restart the plugin after saving the configuration for the change to take effect.':
            'É necessário reiniciar o plugin após salvar a configuração para que a mudança tenha efeito.',
        'At least one equipment (Hydratong, Hydraracker, or Top Drive) must be selected to start reprocessing.':
            'Pelo menos um equipamento (Hydratong, Hydraracker ou Top Drive) deve ser selecionado para iniciar o reprocessamento.',
        'Pipes Module': 'Módulo Pipes',
        'KPI Pipes Module Compression was updated successfully.':
            'Módulo Pipes de Compressão de KPI foi atualizado com sucesso.',
        'By default, the only functionality that uses @@assetWidgetOverrideFilter is "KPI RIG STATE CHANNELS" widget on the 24h dashboard. It might also slow Static Data Widget dashboard.':
            'Por padrão, a única funcionalidade que utiliza @@assetWidgetOverrideFilter é o widget "KPI RIG STATE CHANNELS" no dashboard 24h. Desativar também pode gerar lentidão no dashboard Static Data',
        'Are you sure you want change @@assetWidgetOverrideFilter pipes module?':
            'Você tem certeza de que deseja alterar o módulo Pipes @@assetWidgetOverrideFilter?',
        'You have to restart plugin-kpis-drilling so this change takes effect.':
            'Você precisa reiniciar o plugin-kpis-drilling para que esta mudança tenha efeito.',
        'Disabling this toggle will turn off channel compression @@assetWidgetOverrideFilter Pipes Module, used by default in the “KPI Rig State Channels” widget in the 24h dashboard. It may also break any widgets and features that use it, as well as slow down the "Static Data" Widget dashboard.':
            'Desabilitar este toggle irá desligar a compressão de canais @@assetWidgetOverrideFilter usada, por padrão, no widget “KPI Rig State Channels” (Dashboard 24h). Além disso pode quebrar qualquer widget e funcionalidade que utilize este módulo Pipes, e gerar lenditão no widget "Static Data".',
        'At the moment, it is not possible to reprocess KPI data for the requested timespan, as it overlaps Real Time being executed.':
            'Neste momento não é possível reprocessar dados de KPI para o período requisitado, pois ele sobrepõe o processamento em Tempo Real que está sendo executado',
        'Choose a timespan for reprocessing that contains finished stands, with an end date up to':
            'Escolha um período para reprocessar que contenha Stand com data final até',
        'Open console with reprocess query': 'Abrir console com a query de reprocessamento',
        'Be aware that channels widgets performance of Rigs and Wells Performance product (Annotation Tool Widget, Depth vs time on Static data dashboard and KPI RIG STATE CHANNELS on KPIs last 24h ) will be affected  because they use the compressed collection to enable channel data visualization.':
            'Lembre-se que os widgets de canais do Produto de Performance de Sondas e Poços (Annotation Tool Widget, Depth vs time on Static data dashboard and KPI RIG STATE CHANNELS on KPIs last 24h) serão afetados pois eles utilizam a coleção de canais comprimidos para visualização de dados.',
        'You can change the compressed collection suffix name on this configuration. The collection name is always {event_type_name}_{this-suffix}':
            'Você pode alterar o sufixo para a coleção de canais comprimidos. O nome da coleção é sempre {nome_tipo_evento}_{este-sufixo}',
        'Compressed collection events suffix': 'Sufixo da coleção de eventos comprimidos',
        '{event_type_name}_': '{nome_tipo_evento}_',
        'Ml disconnected. Waiting to reconnect.': 'Ml desconectado. Aguarde reconectar.',
        Disconnected: 'Desconectado',
        Completed: 'Finalizado',
        Initializing: 'Inicializando',
        Running: 'Executando',
        Connecting: 'Conectando',
        REPROCESSING: 'Reprocessando',
        Ready: 'Pronto',
        OK: 'Ok',
        'Rigstate reprocess': 'Rigstate reprocess',
        ' This Runner App is already running': 'Este aplicativo já está em execução',
        'Initializing Reprocessing may take a few minutes.':
            'Inicialização do Reprocessamento pode levar alguns minutos.',

        // RIG SUMMARY APP
        'Server local time': 'Hora local do servidor: ',
        'Search for a rig': 'Procurar uma sonda',
        'Rig ID': 'ID da Sonda',
        'Asset Name': 'Nome do Ativo',
        'Asset Type': 'Tipo do Ativo',
        Realtime: 'Tempo Real',
        'Input Rig State': 'Estado da Sonda de Entrada',
        'Current Rig State': 'Estado da Sonda Atual',
        'Last Rig State': 'Último Estado da Sonda',
        'Rig State Status': 'Status do Estado da Sonda',
        Compression: 'Compressão',
        RIG: 'SONDA',
        WELL: 'POÇO',
        ON: 'LIGADO',
        OFF: 'DESLIGADO',
        ERROR: 'ERRO',
        VALID: 'VÁLIDO',
        WARN: 'ATENÇÃO',
        showingKey: 'Você está vendo',
        rigs: 'sondas',
        ofKey: 'de um total de',
        atKey: 'em ',
        'The type and timestamp of the last received Rig State event that was utilized by the Rig State KPI generation algorithm':
            'O tipo e carimbo de data/hora do último evento Rig State recebido que foi utilizado pelo algoritmo de geração de KPI Rig State',
        'Status ERROR indicates that no Rig State KPI and Rig State Draft Events have been generated for over 10 seconds. If the status is VALID, it indicates that a new event has been generated within the last 10 seconds':
            'Status ERRO indica que nenhum KPI Rig State e Evento Rig State Draft foram gerados por mais de 10 segundos. Se o status for VÁLIDO, indica que um novo evento foi gerado nos últimos 10 segundos',
        'Fetching error': 'Erro de busca',
        "Live Rigs or backend Timezone wasn't got": 'Rigs do Live ou backend Timezone não foi obtido',

        // UNIFIER KPI DATABASE
        Loading: 'Carregando',
        'Choose action': 'Escolha a ação',
        'KPI Data QAQC': 'KPI Data QAQC',
        'Data Status': 'Status de dados',
        'Pending silver data unification': 'Pendência em dados Prata unificados',
        'All-Filter': 'Todos',
        'Active-Filter': 'Ativo',
        'Inactive-Filter': 'Inativo',
        Bronze: 'Bronze',
        Silver: 'Prata',
        Gold: 'Ouro',
        'Unified silver deleted': 'Unificado Prata excluído',
        'Not Unified': 'Não Unificado',
        'Asset-Filter': 'Status do Ativo',
        Unified: 'Unificado',
        'Pending Change': 'Mudança Pendente',
        'Awaiting approval gold': 'Aguardando aprovação de dados Ouro',
        'Review Available': 'Revisão disponível',
        'Data Quality': 'Qualidade de Dados',
        'Data Quality Control': 'Controle de Qualidade',
        'Data Quality Timeline': 'Histórico de Qualidade',
        'Data Quality Management': 'Gerenciamento de Qualidade de Dados',
        Bronze: 'Bronze',
        Silver: 'Prata',
        Gold: 'Ouro',
        'Gold data period': 'Período de dados Ouro',
        'All Statuses': 'Todos os status',
        'Filter by': 'Filtrar por',
        'unification status': 'status',
        'Unification Status': 'Status',
        'Unification Period': 'Período',
        'Awaiting approval period': 'Aguardando aprovação',
        'Last Unification': 'Última unificação',
        'Last Unification By': 'Última unificação por',
        'Required field': 'Campo obrigatório',
        'Gold review available': 'Aprovação de dados Ouro disponível',
        'Type here': 'Digite aqui',
        'Auto Data Unifier': 'Unificação automática',
        'Control Layer': 'Camada de Controle',
        'Unify Silver Data': 'Unificar Dados Prata',
        'Revisions are made at the bronze layer and bypassed at the silver layer. When approving, the system processes the largest continuous period of revisions (including unselected ones) and overwrites the gold; dismissing leaves it unchanged. Check the timeline and adjust them if necessary before approving or dismissing.':
            'As revisões são feitas na camada bronze e ignoradas na camada prata. Ao aprovar, o sistema processa o maior período contínuo de revisões (incluindo as não selecionadas) e sobrescreve o ouro; descartar deixa-o inalterado. Verifique o histórico e ajuste-os, se necessário, antes de aprovar ou descartar.',
        'Approve Gold Data': 'Aprovar Dados Ouro',
        'There are gold KPIs in the period informed.': 'Existem KPIs ouro no período informado.',
        'There are no Silver KPIs in the period informed.': 'Não existem KPIs prata no período informado.',
        'All pending selected': 'Todos as pendências selecionadas',
        'pending selected': 'pendência(s) selecionada(s)',
        'Data Unifier': 'Unificação',
        'Pending Change': 'Mudança Pendente',
        'Review Available': 'Revisão disponível',
        'Input Event Type': 'Tipo de evento de entrada',
        'input event type': 'Tipo de evento de entrada',
        'Output Event Type': 'Tipo de evento de saída',
        'output event type': 'Tipo de evento de saída',
        'unified period': 'Período unificado',
        'Unified Period': 'Período unificado',
        'Unified silver pending': 'Pendência em dados Prata unificados',
        'Bronze data quality': 'Qualidade de dados Bronze',
        'Silver data quality': 'Qualidade de dados Prata',
        'Gold data quality': 'Qualidade de dados Ouro',
        'Unified silver pending': 'Pendência em dados Prata unificados',
        'Approved gold review': 'Revisão de dados Ouro aprovados',
        'Dismissed silver change': 'Mudança de dados Prata descartada',
        'Dismissed gold review': 'Revisão de dados Ouro descartada',
        'Awaiting approval gold': 'Aguardando aprovação de dados Ouro',
        'Cancel request approval gold': 'Cancelar solicitação de aprovação de dados Ouro',
        'timeline-by': 'por',
        'timeline-on': 'em',
        'data-persistence-to': 'até',
        'Request for approval has been made.': 'Solicitação de aprovação foi feita.',
        'Period for approval:': 'Período para aprovação:',
        'pending data unification': 'Dados pendentes',
        'No data changes': 'Sem modificações de dados',
        'timespan to unify': 'Período para unificação',
        'Cancel Request': 'Cancelar solicitação',
        'pendings unified': 'pendências unificadas',
        'Date to Edit': 'Data para edição',
        'Unify successfully applied.': 'Unificação aplicada com sucesso.',
        'Successfully cancelled.': 'Cancelamento realizado com sucesso.',
        'Cancel request approval': 'Cancelar solicitação de aprovação',
        'For some reason it was not possible to cancel.': 'Por algum motivo não foi possível cancelar.',
        'For some reason it was not possible to unify this asset.':
            'Por algum motivo não foi possível unificar este ativo.',
        'Unified period deletion has been done successfully.': 'A exclusão do período unificado foi feita com sucesso.',
        'timespan to Control Layer': 'Período para Camada de Controle',
        'For some reason it was not possible to delete the unified period for this asset.':
            'Por algum motivo não foi possível excluir o período unificado deste ativo.',
        'It was not possible to remove the unified period for this asset. Please contact the support.':
            'Não foi possível excluir o período unificado deste ativo. Entre em contato com o suporte.',
        'Unable to fetch unifying assets for rig.': 'Não foi possível buscar ativos unificados para a sonda.',
        'Unable to fetch': 'Não foi possível buscar',
        'updating status.': 'atualizando status.',
        'Unable to stop': 'Não foi possível parar',
        'unifying.': 'unificando.',
        'Dismiss successfully applied.': 'Pendência descartada com sucesso.',
        'For some reason it was not possible apply dismiss this pending for this asset.':
            'Por algum motivo não foi possível aplicar o descarte desta pendência para este ativo.',
        'Error trying create timeline item.': 'Erro ao tentar criar item de histórico.',
        'Dismiss successfully applied.': 'Pendência descartada com sucesso.',
        'The KPIs, static data and existing goals and KPI omission rules for the selected timespan, will be copied and unified as a single database.':
            'Os KPIs, dados estáticos e regras de omissão de KPI existentes para o período selecionado, serão copiados e unificados como uma única base de dados.',
        'You must have permission to approve gold data. If you do not have permission, after clicking the "Approve gold data" button, a request will be generated for an authorized user to approve it. Alternatively, you can ask your administrator for permission to approve gold data.':
            'Você deve ter permissão para aprovar dados ouro. Se você não tiver permissão, após clicar no botão "Aprovar dados ouro", uma solicitação será gerada para um usuário autorizado aprová-lo. Alternativamente, você pode pedir ao administrador permissão para aprovar dados ouro.',
        Start: 'Início',
        unify: 'unificar',
        Unify: 'Unificar',
        dismiss: 'descartar',
        Dismiss: 'Descartar',
        'Enable timespan selection': 'Permitir seleção por tempo',
        'unify all': 'Unificar todos',
        'The KPIs, static data and existing goals for the selected timespan, will be copied and unified as a single collection.':
            'Os KPIs, dados estáticos e metas existentes, para o período selecionado, serão copiados e unificados em uma coleção única',
        'Unified Data': 'Dados unificados',
        'Re-approve Gold Data': 'Reaprovar dados ouro',
        Unified: 'Unificado',
        Pending: 'Pendente',
        Unifying: 'Unificando...',
        'Not Unified': 'Não unificado',
        All: 'Todos',
        Error: 'Erro',
        'Data Changes': 'Alterações de Dados',
        'Update Date': 'Data de Atualização',
        'Justification for change': 'Justificativa para alteração',
        'Change made': 'Alteração feita:',
        'Timespan to Control Layer': 'Período para Camada de Controle',
        Period: 'Periodo:',
        pending: 'pendente',
        unified: 'unificado(s)',
        review: 'revisão',
        reviews: 'revisões',
        'review-approved': 'aprovada(s)',
        'timeline-dismissed': 'descartada(s)',
        'timeline-pending': 'pendência',
        'timeline-pendings': 'pendências',
        'timeline-unified': 'unificada(s)',
        'timeline-period': 'Período',
        Justification: 'Justificativa',
        approved: 'aprovado',
        dismissed: 'descartado(s)',
        pendings: 'pendências',
        User: 'Usuário:',
        'Start Date': 'Data do Início',
        'End Date': 'Data do Fim',
        'Start and End Date': 'Data de Início e Fim',
        Active: 'Ativo',
        Inactive: 'Inativo',
        unifyingKey: 'Unificando',
        'Search for an asset': 'Procure um ativo',
        'Error while trying to unify data. Click Stop to retry. For more information, check Live log.':
            'Erro enquanto os dados eram unificados. Aperte Parar para tentar novamente. Para mais informações, verifica o log do Live.',
        // GOALS VERSIONING
        'Goals Versioning': 'Versionamento de Metas',
        'Saved by': 'Salvo por',
        'Versioned Goal Status': 'Status da Meta Versionada',
        'Type of change': 'Tipo da mudança',
        Date: 'Data',
        'Changed by': 'Alterado por',
        CREATION: 'CRIAÇÃO',
        UPDATE: 'ATUALIZAÇÃO',
        DELETION: 'DELEÇÃO',
        'Versioned Goals State': 'Estado das Metas Versionadas',
        'Total Goals': 'Total de Metas',
        GLOBAL_GOAL: 'Meta Global',
        LOCAL_GOAL: 'Meta Local',
        EDITED_GLOBAL_GOAL: 'Meta Global Editada',
        'Delete Unified Period': 'Excluir Período Unificado',
        'Remove the unified period': 'Excluir o período unificado',
        'from the asset': 'do ativo',
        'This action cannot be undone.': 'Essa ação não pode ser desfeita.',
        'For some reason it was not possible to unify this asset.':
            'Por algum motivo não foi possível unificar este ativo.',
        'It was not possible to unify this asset for this period. Please contact the support.':
            'Não foi possível unificar este ativo para este período. Entre em contato com o suporte.',
        'For some reason it was not possible to delete the unified period for this asset.':
            'Por algum motivo não foi possível excluir o período unificado deste ativo.',
        'It was not possible to remove the unified period for this asset. Please contact the support.':
            'Não foi possível excluir o período unificado deste ativo. Entre em contato com o suporte.',
        'Unified period deletion has been done successfully.': 'A exclusão do período unificado foi feita com sucesso',
        // KPI Options
        'RIG STATE PRESETS': 'PREDEFINIÇÕES DE ESTADO DA SONDA',
        'Rig state presets are available and configurable on rig models configuration.':
            'As predefinições de estado da sonda estão disponíveis e podem ser configuradas na configuração dos modelos do equipamento.',

        // Omission KPI
        'New Rule': 'Nova Regra',
        'Edit Rule': 'Editar Regra',
        'New Omission Rule': 'Nova Regra de Omissão',
        'Rules list': 'Lista de Regras',
        'Rule Name': 'Nome da Regra',
        'Search Rules': 'Pesquisar Regras',
        'Rule Status': 'Status da Regra',
        'LAST UPDATE': 'ÚLTIMA ATUALIZAÇÃO',
        'Available assets': 'Ativos disponíveis',
        'Added assets': 'Ativos adicionados',
        'Search rig': 'Buscar sonda',
        'Omission KPI': 'Omissão de KPI',
        Indicator: 'Indicador',
        'KPI Indicator': 'Indicador KPI',
        'Kpi Indicator': 'Indicador Kpi',
        'Length bit depth': 'Delta Bit Depth (Final Bit depth - Início Bit depth)',
        Value: 'Valor',
        Begin: 'Início',
        BEGIN: 'INÍCIO',
        END: 'FIM',
        end: 'fim',
        Speed: 'Speed',
        'Timestamp in ms': 'Timestamp em ms',
        Section: 'Seção',
        Tatic: 'Tática da Intervenção',
        'Rig Table Status': 'Status da Mesa Rotativa',
        Responsible: 'Responsável',
        'Section OD': 'Diâmetro da Seção',
        'Stand type': 'Tipo de Stand',
        'Stand size': 'Tamanho de Stand',
        'Stand status': 'Status do Stand',
        'Stand Count': 'Tamanho Stand',
        'Stand count': 'Tamanho stand',
        'Run Type': 'Tipo de Corrida',
        'Material type': 'Tipo de Material do Tubular',
        'Connection Type': 'Tipo de Conexão do Tubular',
        'Tubular Type': 'Tipo de Tubular',
        'Hole Status': 'Status do Poço',
        'Hole status': 'Status do poço',
        'Intervention Tatic': 'Tática da Intervenção',
        greaterThan: 'Maior que',
        lessThan: 'Menor que',
        equals: 'Igual',
        notEquals: 'Diferente',
        greaterOrEquals: 'Maior ou igual',
        'No rules found': 'Nenhuma regra encontrada',
        'Create a new rule': 'Crie uma nova regra',
        lessOrEquals: 'Menor ou igual',
        'KPI Event Conditionals': 'Condicionais de Eventos KPI',
        'KPI Conditionals Reference Values': 'Valores de Referência das Condicionais de KPI',
        'Stand Conditionals': 'Condicionais do Stand',
        'Static Data Conditionals': 'Condicionais dos Dados Estáticos',
        'Logical Operators': 'Operadores Lógicos',
        ruleDescriptionP1:
            'Uma regra determina quais KPIs serão omitidos de cálculos e visualizações. A regra se aplica ao KPI unificado, que deverá ser reprocessado no período desejado para que a regra tenha efeito. Os KPIs omitidos permanecem na coleção de KPIs unificados, porém não serão exibidos em dashboards como "Dynamic Chart" e "RPI management".',
        ruleDescriptionP2:
            'A regra funciona combinando diferentes critérios condicionais. Habilite as condicionais desejadas e escolha valor e operador lógico. As condicionais não habilitadas serão desconsideradas na regra de omissão. Por exemplo, se você criar uma regra para omitir KPIs do tipo "S2S" com duração superior a 30 minutos, e não especificar o campo "tipo de tubular", todos os KPIs "S2S" com a duração especificada serão omitidos, independentemente do tipo de tubular.',
        ruleDescriptionP3:
            'Ex.: Indicador de KPI: Valor ("S2S"); Operador lógico ("Igual a") e Duração do KPI: Valor ("30"); Operador lógico (>).',
        'Unified period deletion has been done successfully.': 'A exclusão do período unificado foi feita com sucesso',
        'create database': 'criar banco de dados',
        'No table found': 'Nenhuma tabela encontrada',
        'Create a new table': 'Criar uma nova tabela',
        'New Connection': 'Nova Conexão',
        'Source Connection': 'Conexão de Origem',
        'Data Aggregation Service': 'Serviço de Agregação de Dados',
        'Application Identifier': 'Identificador da Aplicação',
        'Application identifier': 'Identificador da aplicação',
        'Table Name': 'Nome da Tabela',
        'New Data Table': 'Nova Tabela de Dados',
        'Data Source Connection': 'Conexão da Fonte de Dados',
        'Connection Name': 'Nome da Conexão',
        Password: 'Senha',
        'Test connection': 'Testar conexão',
        'Enter with connection name': 'Digite o nome da conexão',
        'Enter with url': 'Digite a url',
        'Enter with username': 'Digite o nome de usuário',
        'Enter with password': 'Digite a senha',
        'Create dataset': 'Criar conjunto de dados',
        'Dataset Name': 'Nome do Conjunto de Dados',
        Tables: 'Tabelas',
        'Superset Send Progress': 'Progresso de Envio ao Superset',
        Loading: 'Carregando',
        'Could not fetch send progress.': 'Não foi possível buscar o progresso de envio.',
        Status: 'Status',
        'Rows Sent': 'Linhas Enviadas',
        'The value in parentheses represents the number of Tripping Children rows included in the total.':
            'O valor entre parênteses representa o número de linhas de Tripping Children incluídas no total.',
        'Batches Sent': 'Lotes Enviados',
        Duration: 'Duração',
        'Unified Dashboard': 'Dashboard Unificado',
        'Fleet Dashboard': 'Dashboard de Frota',
        Created: 'Criado',
        Failed: 'Falhou',

        // Fleet Overview filters
        'Critical path': 'Caminho crítico',
        'Non critical path': 'Caminho não crítico',
        'Last 30 days': 'Últimos 30 dias',

        ...fleetOverviewPt,
        // Code Management & KPI Goals
        'Are you sure you want to restore this entry?': 'Tem certeza que deseja restaurar esta entrada?',
        Code: 'Código',
        'CodeManagement entry updated successfully.': 'Entrada do Code Management atualizada com sucesso.',
        Custom: 'Personalizado',
        Description: 'Descrição',
        'Display Code': 'Código de Exibição',
        'System Code': 'Código do Sistema',
        'Edit Code in Code Management': 'Editar Código no Code Management',
        'Entry restored successfully.': 'Entrada restaurada com sucesso.',
        'Failed to update CodeManagement entry': 'Falha ao atualizar entrada do Code Management',
        'Logs Settings': 'Configurações de Logs',
        RESTORE: 'RESTAURAR',
        'Restore Global Goal': 'Restaurar Meta Global',
        'Select...': 'Selecionar...',
        'Stand Size Settings': 'Configurações de Stand',
        unit: 'unidade',

        // Dynamic Dashboard Send
        'Dynamic Dashboard Status': 'Status do Dashboard Dinâmico',
        'Displays the result of the latest data publication to Dynamic Dashboards':
            'Exibe o resultado da última publicação de dados nos Dashboards Dinâmicos',
        Sending: 'Enviando',
        Checking: 'Verificando',
        'Send Single Rig': 'Enviar Sonda Específica',
        'Send All Rigs': 'Enviar Todas as Sondas',
        'Send failed': 'Falha no envio',
        'The Unified to SQL plugin is unavailable. The send would be aborted by the server.':
            'O plugin Unified to SQL está indisponível. O envio seria abortado pelo servidor.',
        'The Superset integration plugin is unavailable. Data will be sent, but no dashboard will be created.':
            'O plugin de integração com o Superset está indisponível. Os dados serão enviados, mas nenhum dashboard será criado.',
        'Could not check plugin availability before sending.':
            'Não foi possível verificar a disponibilidade dos plugins antes do envio.',
        'Enter rig ID': 'Digite o ID da sonda',
        Send: 'Enviar',
        Updated: 'Atualizado',
        'Already available': 'Já disponível',
        'Process Status': 'Status do Processo',
        'KPIs Found': 'KPIs Encontrados',
        'Total KPIs identified in the selected period. Values in parentheses represent KPIs integrated into parent KPIs':
            'Total de KPIs identificados no período selecionado. Os valores entre parênteses representam KPIs integrados a KPIs pai',
        'KPIs Sent': 'KPIs Enviados',
        'Total KPIs successfully published to Dynamic Dashboards. Values in parentheses represent KPIs integrated into parent KPIs.':
            'Total de KPIs publicados com sucesso nos Dashboards Dinâmicos. Os valores entre parênteses representam KPIs integrados a KPIs pai.',
        'Dashboard Status': 'Status do Dashboard',
        Details: 'Detalhes',
        'Unknown error': 'Erro desconhecido',
        'No send operation in progress.': 'Nenhuma operação de envio em andamento.',
        'No unified KPIs found for the selected filter.': 'Nenhum KPI unificado encontrado para o filtro selecionado.',
        'Searching for unified KPIs to send': 'Buscando KPIs unificados para enviar',
        'Could not load the rig list.': 'Não foi possível carregar a lista de sondas.',
        'Extent': 'Extensão',
        'month': 'mês',
        'months': 'meses',
        'ALL RIGS': 'TODAS AS SONDAS',
        'This removes unified KPI data for every rig, across': 'Isto remove dados de KPI unificado de todas as sondas, ao longo de',
        'I understand this affects every rig.': 'Entendo que isto afeta todas as sondas.',
        'Time window': 'Janela de tempo',
        'Mode': 'Modo',
        'Between two dates': 'Entre duas datas',
        'Everything before': 'Tudo antes de',
        'Everything after': 'Tudo depois de',
        'Before': 'Antes de',
        'After': 'Depois de',
        'All rigs': 'Todas as sondas',
        'all rigs': 'todas as sondas',
        'rig': 'sonda',
        'Preview window': 'Pré-visualizar janela',
        'Resolving': 'Resolvendo',
        'Window': 'Janela',
        'Scope': 'Escopo',
        'Send window': 'Enviar janela',
        'Delete window': 'Excluir janela',
        'Deleting': 'Excluindo',
        'Delete failed': 'Falha na exclusão',
        'The start date is after the end date.': 'A data inicial é posterior à data final.',
        'No unified data found for the selected scope.': 'Nenhum dado unificado encontrado para o escopo selecionado.',
        'The resolved window is empty: no unified data on that side of the date.': 'A janela resolvida está vazia: não há dados unificados desse lado da data.',
        'Could not resolve the time window.': 'Não foi possível resolver a janela de tempo.',
        'One edge was resolved from the existing data.': 'Uma das bordas foi resolvida a partir dos dados existentes.',
        'Remove all unified KPI data in the window below.': 'Remover todos os dados de KPI unificado na janela abaixo.',
        'Confirm': 'Confirmar',
        'Cancel': 'Cancelar',
        'The Unified to SQL plugin is unavailable.': 'O plugin Unified to SQL está indisponível.',
        'You need the OGPERFORMANCE_MANAGE_KPI or OGPERFORMANCE_ADMINISTRATE_KPI authority.':
            'Você precisa da permissão OGPERFORMANCE_MANAGE_KPI ou OGPERFORMANCE_ADMINISTRATE_KPI.',
        // OGP21-5245 UI: deixar explícito o destino dos dados (banco do Superset, não o Live)
        'Publishes and removes the unified KPIs in the Superset database (dashboards). It does not change Live data.':
            'Publica e remove os KPIs unificados no banco do Superset (dashboards). Não altera os dados do Live.',
        'Publishes the unified KPIs to the Superset database (dashboards). Does not change Live.':
            'Publica os KPIs unificados no banco do Superset (dashboards). Não altera o Live.',
        'Removes the unified KPI data published to Superset (dashboards) in the window below. It does not remove anything from Live.':
            'Remove os dados de KPI unificado publicados no Superset (dashboards) na janela abaixo. Não remove nada do Live.',
        'This removes unified KPI data for every rig, {window}.':
            'Isto remove dados de KPI unificado de todas as sondas, {window}.',
        'This removes unified KPI data for every rig, across {count} {unit}.':
            'Isto remove dados de KPI unificado de todas as sondas, ao longo de {count} {unit}.',
        // OGP21-5245 UI: chaves que a tela usava sem tradução PT (caíam em inglês)
        'Only KPIs entirely on that side of the date are removed; a KPI that crosses it is kept.':
            'Apenas KPIs inteiramente desse lado da data são removidos; um KPI que a cruza é mantido.',
        'Collection Name': 'Nome da coleção',
        'Not available': 'Não disponível',
        'Not modified': 'Não modificado',
        'Skipped': 'Ignorado',
        'Legacy tables': 'Tabelas legadas',
        'rows removed': 'linhas removidas',
        'dropped': 'removidas',
        'kept': 'mantidas',
        'views': 'visões',
        'Partitions dropped': 'Partições removidas',
        'Choose date': 'Escolher data',
        'Hour:': 'Hora:',
        'Period': 'Período',
        'Duration': 'Duração',
        'Completed': 'Concluído',
        'Created': 'Criado',
        'Failed': 'Falhou',
        'Loading': 'Carregando',
        // OGP21-5245 UI F-01: stall guard
        'The send status stopped updating. It may have finished — check now to confirm.':
            'O status do envio parou de atualizar. Pode já ter concluído — verifique agora para confirmar.',
        'Check now': 'Verificar agora',
        // OGP21-5245 UI F-03: feedback das ações
        'Send requested. Follow the progress below.': 'Envio solicitado. Acompanhe o progresso abaixo.',
        'Delete requested. Follow the progress below.': 'Exclusão solicitada. Acompanhe o progresso abaixo.',
        // OGP21-5245 UI PR-01/S-02/S-03: barra de progresso e confirmação do envio da frota
        '{completed} of {total} periods': '{completed} de {total} períodos',
        '{failed} failed': '{failed} com falha',
        'This publishes the unified KPIs for all rigs to the Superset database (dashboards). It does not change Live.':
            'Isto publica os KPIs unificados de todas as sondas no banco do Superset (dashboards). Não altera o Live.',
        'Rigs with unified data: {count}': 'Sondas com dados unificados: {count}',
        // OGP21-5245 UI C-04/P-01: rótulo de escopo e carregamento da lista de sondas
        'rig {name}': 'sonda {name}',
        'Loading rigs': 'Carregando sondas',
        // OGP21-5245 UI S-05/S-04: dica do estado vazio e nota de fuso dos timestamps
        'Try widening the time window or run a Preview window.':
            'Tente ampliar a janela de tempo ou use Pré-visualizar janela.',
        'Shown in your local time zone.': 'Exibido no seu fuso horário local.',
        // OGP21-5245 R10 — dynamic dashboard status: goal timestamps, no_op, refresh warning
        'Global goals last updated': 'Metas globais atualizadas em',
        'goals last updated': 'metas atualizadas em',
        'No goals of its own (uses Global)': 'Sem metas próprias (usa as globais)',
        'Goals changed after this send started. Send again to apply them.': 'As metas mudaram depois do início deste envio. Envie de novo para aplicá-las.',
        'Do not refresh the Superset dashboard until this operation is COMPLETED.': 'Não atualize o dashboard do Superset até esta operação estar COMPLETED.',
        'Result': 'Resultado',
        'Last send started': 'Último envio iniciado em',
        'Could not load the goals last-updated times.': 'Não foi possível carregar as datas de atualização das metas.',
        'No rig had unified KPIs for the requested rig or window.': 'Nenhuma sonda tinha KPIs unificados para a sonda ou janela pedida.',
        'Every period failed: nothing was written or removed.': 'Todos os períodos falharam: nada foi gravado nem removido.',
        'The periods were processed but no row was written, so there was nothing to refresh.': 'Os períodos foram processados, mas nenhuma linha foi gravada; não havia nada a atualizar.',
        'The delete found nothing to remove in the requested window.': 'A exclusão não encontrou nada a remover na janela pedida.'
    }
}
